import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "types/store";
import { Dialog, DialogContent, DialogFooter, DialogHeader } from "@/aible/Dialog/Dialog";
import { Button, ButtonGroup, Accordion, Icon } from "aible";
import { toast } from "react-toastify";
import AlwaysOnIcon from "images/Optimize-Agent-Icon.svg";
import Select from "react-select";
import styles from "./style.module.css";
import ToneSelector from "../ChatGPT/ToneSettings/ToneSelector";
import { AibleClientFactory } from "client/aible/factory";
import CronExpressionInput from "components/Tiles/Sense/CronExpressionInput";
import TimezoneInput from "components/Tiles/Sense/TimezoneInput";
import { PrismAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import ChatGPT from "../ChatGPT/ChatGPT";
import { SkillsOverview } from "components/AibleAgent/AibleAgent";
import * as blueprintReducer from "@/containers/Blueprint/reducer";
import * as viewReducer from "@/containers/View/reducer";
import * as chatGPTReducer from "@/containers/ChatGPT/reducer";
import * as aibleAnywhereReducer from "@/containers/AibleAnywhere/reducer";
import * as accountsReducer from "@/containers/Accounts/reducer";
import * as aiServiceReducer from "@/containers/AiService/reducer";
import * as globalReducer from "@/containers/App/reducer";
import * as homeReducer from "@/containers/Home/reducer";
import { getMultiSessionMemoryTypes, getMultiSessionMemoryCount, getMultiSessionMemoryTypeById } from "@/containers/ChatGPT/features/ConversationMemory/selectors";
import { CLAW_HIDDEN_TOOLS } from "@/containers/AibleAnywhere/reducer";
import { getDefaultGuardrailsInputInstruction, getDefaultGuardrailsOutputInstruction, getDefaultGuardrailsSystemInstruction, AGENTIQ_TASK_INSTRUCTIONS, CHATAIBLE_AGENT_C } from "@/containers/ChatGPT/reducer";
import ShieldIcon from "images/shield-check-light-full 1.svg";
import EditIcon from "images/edit-light.svg";
import BoltIcon from "images/bolt-auto-light-full.svg";
import BoltIconPurple from "images/bolt-auto-light-full-purple.svg";
import ScrewDriverWrenchIcon from "images/screwdriver-wrench-light-full.svg";
import ScrewDriverWrenchIconPurple from "images/screwdriver-wrench-light-full-purple.svg";
import CompassTaskIcon from "images/SafeClawIcons/compass-light-full 1.svg";
import MessageBotIcon from "images/SafeClawIcons/message-bot.svg";
import ShieldTaskIcon from "images/SafeClawIcons/shield-check-light-full 3.svg";
import MemoryTaskIcon from "images/SafeClawIcons/brain-circuit-light-full 1.svg";
import AgentTaskIcon from "images/SafeClawIcons/Conveyor Belt Arm Light 1.svg";
import CircleCheckIcon from "images/SafeClawIcons/Circle Check Icon 1.svg";
import AibleIcon from "images/SafeClawIcons/Aible_Badge-Full-Color.svg";
import UsageStats from "images/SafeClawIcons/usage-stats.svg";
import ToolsIcon from "images/SafeClawIcons/box-open-full-sharp-light-full 1.svg";
import FlaggedRequestsBellIcon from "images/SafeClawIcons/bell-ring-light-full 1.svg";
import ApiKeysIcon from "images/SafeClawIcons/key.svg";
import SkillsLightbulbIcon from "images/SafeClawIcons/skills.svg";
import DatasetSelector from "components/Dataset/DatasetSelector";
import BlueprintSelector from "../ChatGPT/BlueprintSelector";
import DocumentSelector from "components/LanguageModelArtifact/DocumentSelector";
import TextInput from "components/Inputs/TextInput";
import UndoArrowIcon from "images/arrow-rotate-left-sharp-gray.svg";
import LoadingIndicator from "../LoadingIndicator/LoadingIndicator";
import ToneSettings from "components/ChatGPT/ToneSettings/ToneSettings";
import ModelSelector from "components/ChatGPT/ModelSelector";
import { isEnabled } from "@/utils/featureFlags";
import Tooltip from "components/Inputs/Tooltip";
import LabeledToggle from "@/components/Inputs/Toggle/Toggle";
import cronstrue from "cronstrue";
import * as nextReducer from "@/containers/Next/NextReducer";
import * as reportReducer from "@/containers/Report/ReportReducer";
import FlaggedNetworkRequests from "../Openshell/FlaggedNetworkRequests";
const AgentCModal = ({ agent = undefined, open, onOpenChange, isModal, isNewCreate }) => {
    const dispatch = useDispatch();
    const [useCache, setUseCache] = useState(false);
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const [agentC, setAgentC] = useState(agent ??
        {
            name: "New Agent",
            isAgentC: true,
            accountId: accountId
        });
    return isNewCreate ? (React.createElement(AgentCreate, { agent: agentC, setAgent: setAgentC, open: open, onOpenChange: () => onOpenChange(!open), useCache: useCache, setUseCache: setUseCache })) : isModal !== true ? (React.createElement(AgentC, { agent: agentC, setAgent: setAgentC, useCache: useCache, setUseCache: setUseCache })) : (React.createElement(Dialog, { open: open, onOpenChange: () => onOpenChange(!open) },
        React.createElement(DialogContent, { size: "lg", showCloseButton: true },
            React.createElement(DialogHeader, null,
                React.createElement("div", { className: styles.agentCHeader },
                    React.createElement("div", { className: styles.wizardHeaderLogoWrapper },
                        React.createElement("img", { className: styles.wizardHeaderLogo, src: AlwaysOnIcon })),
                    `${CHATAIBLE_AGENT_C.name} Setup`)),
            React.createElement(AgentC, { agent: agentC, setAgent: setAgentC, useCache: useCache, setUseCache: setUseCache }),
            React.createElement(DialogFooter, null,
                React.createElement("div", { className: styles.modalFooterActions, style: { justifyContent: "space-between" } },
                    React.createElement(Button, { onClick: () => onOpenChange(false) }, "Cancel"),
                    React.createElement(Button, { type: "primary", onClick: () => dispatch(aibleAnywhereReducer.saveAibleAnywhere(agentC, agentC?.name)) }, "Save"))))));
};
const AgentCreate = ({ agent = undefined, setAgent, open, onOpenChange, useCache, setUseCache }) => {
    const dispatch = useDispatch();
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const [isManualAgent, setIsManualAgent] = useState(false);
    const [isGeneratingAgent, setIsGeneratingAgent] = useState(false);
    const [agentGenPrompt, setAgentGenPrompt] = useState("");
    const [agentPrompt, setAgentPrompt] = useState("");
    const [currentTestCronjob, setCurrentTestCronjob] = useState("");
    const generateAgentC = useSelector((state) => aibleAnywhereReducer.getGenerateAgentC(state));
    const setGenAgent = (retGenAgentC) => dispatch(aibleAnywhereReducer.updateGenerateAgentC(retGenAgentC));
    const conversation = useSelector((state) => chatGPTReducer.getConversation(state));
    const [isHideTest, setIsHideTest] = useState(false);
    const isFullscreen = Object.keys(conversation ?? {}).length > 0 && isHideTest !== true;
    const isLargeScreen = isManualAgent || isGeneratingAgent || generateAgentC !== undefined;
    const [testName, setTestName] = useState("Test Task");
    const [isCreatingAgent, updateIsCreatingAgent] = useState(false);
    const [prevGenPrompt, setPrevGenPrompt] = useState(undefined);
    const [showGenerationPrompt, setShowGenerationPrompt] = useState(false);
    const promptRef = useRef(null);
    const retAgent = isManualAgent
        ? agent
        : {
            accountId: accountId,
            isAgentC: true,
            ...generateAgentC
        };
    useEffect(() => {
        const initChat = async () => {
            dispatch(chatGPTReducer.init());
        };
        initChat();
    }, []);
    useEffect(() => {
        if (open && promptRef?.current) {
            promptRef.current.focus();
        }
    }, [open]);
    const forceCronJob = async (cronJob, i) => {
        const retAgent = isManualAgent ? agent : generateAgentC;
        const retName = aibleAnywhereReducer.getTaskName("cronJobs", i);
        setTestName(retName);
        setIsHideTest(false);
        setCurrentTestCronjob(cronJob);
        //const sAgent = await dispatch(aibleAnywhereReducer.saveAibleAnywhere(retAgent, retAgent?.name, false));
        await dispatch(aibleAnywhereReducer.testCronJob(retAgent?.id, {
            ...cronJob,
            name: retName,
            index: i,
            type: "cronJobs"
        }, i, useCache));
        setIsHideTest(false);
    };
    const forceApiInvocation = async (apiInvocation, i) => {
        const retAgent = isManualAgent ? agent : generateAgentC;
        const retName = aibleAnywhereReducer.getTaskName("apiInvocations", i);
        setTestName(retName);
        setIsHideTest(false);
        setCurrentTestCronjob(apiInvocation);
        //const sAgent = await dispatch(aibleAnywhereReducer.saveAibleAnywhere(retAgent, retAgent?.name, false));
        await dispatch(aibleAnywhereReducer.testApiInvocation(retAgent?.id, {
            ...apiInvocation,
            name: retName,
            index: i,
            type: "apiInvocations"
        }, i, useCache));
        setIsHideTest(false);
    };
    const continueChat = async (cronJob, prompt) => {
        let retBlueprintOptions = [...(cronJob?.blueprintOptions ?? [])];
        if (aibleAnywhereReducer.shouldInjectSlackTool(cronJob)) {
            retBlueprintOptions.push({
                id: 11,
                third_party_tool_id: cronJob?.slackChannel?.value,
                name: "post_report_to_channel"
            });
        }
        dispatch(chatGPTReducer.handleAgentIQ(prompt, false, "reasoning", undefined, agent?.id, retBlueprintOptions, useCache));
    };
    const resetModalState = async () => {
        await dispatch(chatGPTReducer.cancelAgent(true));
        dispatch(aibleAnywhereReducer.updatePredictNextId(undefined));
        dispatch(chatGPTReducer.init());
        dispatch(chatGPTReducer.updateConversation({})); // Resetting the conversation on modal reset
        setAgent(undefined);
        setIsManualAgent(false);
        setIsGeneratingAgent(false);
        setAgentGenPrompt("");
        setAgentPrompt("");
        setCurrentTestCronjob("");
        setGenAgent(undefined);
        setIsHideTest(false);
        setTestName("Test Task");
        updateIsCreatingAgent(false);
        setPrevGenPrompt(undefined);
    };
    const handleResetModal = () => {
        if (open) {
            resetModalState();
        }
        onOpenChange(!open);
    };
    const handleCreateClawAgent = async (agent, name) => {
        updateIsCreatingAgent(true);
        const newAgent = await dispatch(aibleAnywhereReducer.saveClawAgent(agent, name));
        dispatch(viewReducer.initOpenAibleClawAgent(newAgent?.id));
        updateIsCreatingAgent(false);
        handleResetModal();
    };
    const handleGenerateAgentSettings = async () => {
        setIsGeneratingAgent(true);
        const tryGenerateAgentC = () => dispatch(aibleAnywhereReducer.generateAgentC(agentGenPrompt));
        let genAgentReponse;
        for (let retries = 0; retries < 3; retries++) {
            try {
                genAgentReponse = await tryGenerateAgentC();
                break;
            }
            catch (error) { }
        }
        if (genAgentReponse !== undefined) {
            setPrevGenPrompt(agentGenPrompt);
            setGenAgent({ ...genAgentReponse });
            console.log("what is genAgentReponse?/", genAgentReponse);
        }
        setIsGeneratingAgent(false);
    };
    const hasValidAgent = aibleAnywhereReducer.isValidClawAgent(retAgent);
    const disableCreateAgent = !hasValidAgent || isGeneratingAgent;
    const hasGenAgent = generateAgentC !== undefined;
    const hasModifiedGenPrompt = hasGenAgent && prevGenPrompt && agentGenPrompt !== prevGenPrompt;
    const generatingAgentLoadingIndicatorStyle = {
        height: "64px",
        width: "40px",
        margin: "0px",
        marginTop: "-4px",
        marginLeft: "-12px",
        transform: "scale(0.4)"
    };
    const predictNextId = useSelector((state) => aibleAnywhereReducer.getPredictNextId(state));
    const hasPredictConfig = predictNextId !== undefined;
    return (React.createElement(Dialog, { open: open, onOpenChange: () => handleResetModal() },
        React.createElement(DialogContent, { size: isFullscreen || hasPredictConfig ? "full" : isLargeScreen || hasPredictConfig ? "xl" : "lg", showCloseButton: true, onInteractOutside: (e) => e.preventDefault() },
            React.createElement(DialogHeader, null,
                React.createElement("div", { className: styles.agentCHeader },
                    React.createElement("div", { className: styles.wizardHeaderLogoWrapper },
                        React.createElement("img", { className: styles.wizardHeaderLogo, src: AlwaysOnIcon })),
                    `${CHATAIBLE_AGENT_C.name} Setup` + (hasPredictConfig ? ": Prediction Config" : ""))),
            React.createElement("div", { className: styles.alwaysOnPredictHolder },
                React.createElement("div", { className: styles.alwaysOnChat, style: hasPredictConfig ? { width: "80%" } : {} },
                    React.createElement(ChatGPT, { hideAutonomyControls: true, tryChatTemplate: !hasPredictConfig, safeClawOptimize: hasPredictConfig })),
                React.createElement("div", { className: styles.alwaysOnCreate, style: hasPredictConfig ? { width: "20%" } : {} },
                    React.createElement("div", { className: styles.alwaysOnCreateLeft, style: isFullscreen ? { width: "calc(60% - 10px)", minWidth: "calc(60% - 10px)" } : {} },
                        Object.keys(conversation ?? {}).length > 0 && isHideTest !== true && hasPredictConfig !== true && (React.createElement("div", { className: styles.alwaysOnTestHeader },
                            React.createElement("div", { className: styles.alwaysOnTestBold }, testName),
                            React.createElement("div", { className: styles.testClose },
                                React.createElement(Button, { onClick: () => setIsHideTest(true) }, "Close")))),
                        Object.keys(conversation ?? {}).length > 0 && isHideTest !== true && hasPredictConfig !== true ? (React.createElement("div", { style: { height: "100%" } },
                            React.createElement("div", { style: { height: "calc(100% - 150px)" } },
                                React.createElement(ChatGPT, { skipNextLoading: true, hideFooter: true, hideRightPanel: true, tryChatTemplate: true })),
                            React.createElement("div", { className: styles.alwaysOnFooter },
                                React.createElement("textarea", { className: styles.agentCTextArea, style: { height: "80px", marginRight: "10px", resize: "none" }, value: agentPrompt, placeholder: "Enter message to chat", onChange: (e) => setAgentPrompt(e?.currentTarget?.value), disabled: isManualAgent }),
                                React.createElement(Button, { onClick: () => continueChat(currentTestCronjob, agentPrompt) }, "Ask")))) : !isManualAgent && predictNextId === undefined ? (React.createElement("div", null,
                            !hasGenAgent && !isGeneratingAgent && (React.createElement("div", { className: "mb-[10px]" },
                                React.createElement(ModeSelection, { isManualAgent: isManualAgent, setIsManualAgent: setIsManualAgent }))),
                            React.createElement("div", { className: styles.agentCInput, style: { marginBottom: "10px" } },
                                React.createElement("div", { className: styles.agentCInputBold }, "Describe what you would like to automate"),
                                React.createElement("div", { style: { marginBottom: "12px" } }, "Aible will automatically create an assistant based on what you describe below"),
                                React.createElement("textarea", { className: styles.agentCTextArea, style: { height: "160px" }, value: agentGenPrompt, placeholder: "Describe what you would like the agent to do", onChange: (e) => setAgentGenPrompt(e?.currentTarget?.value), disabled: isManualAgent || isGeneratingAgent, ref: promptRef }),
                                generateAgentC !== undefined && !isGeneratingAgent && (React.createElement(Button, { onClick: () => handleGenerateAgentSettings(), type: hasModifiedGenPrompt ? "primary" : "secondary" }, hasModifiedGenPrompt ? "Regenerate assistant with updated prompt" : "Regenerate assistant"))),
                            React.createElement("div", { className: styles.agentCWarningWrappper },
                                React.createElement("div", { className: styles.agentCWarningItem },
                                    React.createElement("div", { className: styles.agentCWarningIconWrapper },
                                        React.createElement("img", { src: ShieldIcon })),
                                    React.createElement("div", null, "You can review and configure the agent's privacy and memory settings before approving it."))),
                            React.createElement("div", null,
                                React.createElement("div", { style: {
                                        display: "flex",
                                        alignItems: "center"
                                    } },
                                    React.createElement("span", { style: { color: "#202939" } }, "AI Model"),
                                    React.createElement(ModelSelector, { hideIcons: true, isCreatable: true, selectorStyle: {
                                            marginLeft: "15px"
                                        }, style: { flexShrink: "1", whiteSpace: "normal", padding: "2px" }, isDisabled: isGeneratingAgent, menuPlacement: "top" }),
                                    React.createElement(Button, { style: { marginLeft: "10px", padding: "8px 10px" }, active: showGenerationPrompt, onClick: () => {
                                            setShowGenerationPrompt(!showGenerationPrompt);
                                        } },
                                        React.createElement(Icon, { type: "gear" }))),
                                React.createElement(GenerationSettings, { show: showGenerationPrompt })))) : (React.createElement(React.Fragment, null))),
                    isManualAgent ? (React.createElement("div", { className: styles.alwaysOnCreateRight },
                        React.createElement(AgentC, { agent: agent, setAgent: setAgent, forceCronTest: forceCronJob, forceAPITest: forceApiInvocation, isManualAgent: true, setIsManualAgent: setIsManualAgent, useCache: useCache, setUseCache: setUseCache }))) : isGeneratingAgent === true ? (React.createElement("div", { className: styles.alwaysOnCreateRight },
                        React.createElement("div", { className: "p-[14px]" },
                            React.createElement("div", { className: styles.agentCInputBold }, "Creating your always-on assistant"),
                            React.createElement("div", null, "Here are the settings I have applied based on your description"),
                            React.createElement("div", { className: "mt-[20px]" },
                                React.createElement("div", { className: styles.agentBubbleItem },
                                    React.createElement(LoadingIndicator, { style: generatingAgentLoadingIndicatorStyle }),
                                    React.createElement("div", { className: styles.agentBubbleText }, "Understanding intent of the agent description")),
                                React.createElement("div", { className: styles.agentBubbleItem },
                                    React.createElement(LoadingIndicator, { style: generatingAgentLoadingIndicatorStyle }),
                                    React.createElement("div", { className: styles.agentBubbleText }, "Finding the relevant data and tools")),
                                React.createElement("div", { className: styles.agentBubbleItem },
                                    React.createElement(LoadingIndicator, { style: generatingAgentLoadingIndicatorStyle }),
                                    React.createElement("div", { className: styles.agentBubbleText }, "Adding time based actions")),
                                React.createElement("div", { className: styles.agentBubbleItem },
                                    React.createElement(LoadingIndicator, { style: generatingAgentLoadingIndicatorStyle }),
                                    React.createElement("div", { className: styles.agentBubbleText }, "Finishing agent setup")))))) : generateAgentC !== undefined ? (React.createElement("div", { className: styles.alwaysOnCreateRight },
                        React.createElement(AgentC, { agent: generateAgentC, setAgent: setGenAgent, forceCronTest: forceCronJob, forceAPITest: forceApiInvocation, hasGeneratedAgent: true, useCache: useCache, setUseCache: setUseCache }))) : (React.createElement(React.Fragment, null)))),
            React.createElement(DialogFooter, null, hasPredictConfig ? (React.createElement("div", { className: styles.modalFooterActions, style: { justifyContent: "space-between" } },
                React.createElement(Button, { onClick: () => handleResetModal() }, "Cancel"),
                React.createElement(Button, { type: "primary", onClick: () => dispatch(nextReducer.saveNext(predictNextId)), isLoading: isCreatingAgent, disabled: disableCreateAgent }, "Save Prediction Config"))) : isManualAgent || generateAgentC !== undefined ? (React.createElement("div", { className: styles.modalFooterActions, style: { justifyContent: "space-between" } },
                React.createElement(Button, { onClick: () => handleResetModal() }, "Cancel"),
                React.createElement(Button, { type: "primary", onClick: () => handleCreateClawAgent(retAgent, retAgent?.name), isLoading: isCreatingAgent, disabled: disableCreateAgent }, "Create Agent"))) : generateAgentC !== undefined ? (React.createElement("div", { className: styles.modalFooterActions, style: { justifyContent: "space-between" } },
                React.createElement(Button, { onClick: () => handleResetModal() }, "Cancel"),
                React.createElement(Button, { type: "primary", onClick: () => {
                        const newGenAgent = {
                            account_id: accountId,
                            isAgentC: true,
                            ...generateAgentC
                        };
                        handleCreateClawAgent(newGenAgent, newGenAgent?.name);
                    }, isLoading: isCreatingAgent, disabled: disableCreateAgent }, "Create Agent"))) : (React.createElement("div", { className: styles.modalFooterActions, style: { justifyContent: "space-between" } },
                React.createElement(Button, { onClick: () => handleResetModal() }, "Cancel"),
                React.createElement(Button, { type: "primary", onClick: () => handleGenerateAgentSettings(), disabled: isGeneratingAgent }, "Start Generating Assistant")))))));
};
const TemplateSelection = ({ title }) => {
    const dispatch = useDispatch();
    const retTitle = title ?? "Use Instructions from";
    const selectedBlueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const selectedBlueprint = useSelector((state) => blueprintReducer.getBlueprint(state, selectedBlueprintId));
    const blueprintName = selectedBlueprint?.name ? selectedBlueprint.name + " (Updated)" : "New Template";
    const [sTemplateName, setSTemplateName] = useState(blueprintName);
    const [isSaving, setIsSaving] = useState(false);
    useEffect(() => {
        if (sTemplateName !== blueprintName) {
            setSTemplateName(blueprintName);
        }
    }, [selectedBlueprintId]);
    const rawClawAgentGenerationPrompt = useSelector((state) => chatGPTReducer.getClawAgentGenerationPrompt(state, true));
    // Get the saved Blueprint Value (just pass isParent = true)
    const savedClawAgentGenerationPrompt = useSelector((state) => chatGPTReducer.getUseCaseSetting(state, "clawAgentGenerationPrompt", undefined, undefined, true));
    const rawClawAgentGenerationCronJobsPrompt = useSelector((state) => chatGPTReducer.getClawAgentGenerationCronJobsPrompt(state, true));
    // Get the saved Blueprint Value (just pass isParent = true)
    const savedClawAgentGenerationCronJobsPrompt = useSelector((state) => chatGPTReducer.getUseCaseSetting(state, "clawAgentGenerationCronJobsPrompt", undefined, undefined, true));
    const rawClawAgentGenerationApiInvocationsPrompt = useSelector((state) => chatGPTReducer.getClawAgentGenerationApiInvocationsPrompt(state, true));
    // Get the saved Blueprint Value (just pass isParent = true)
    const savedClawAgentGenerationApiInvocationsPrompt = useSelector((state) => chatGPTReducer.getUseCaseSetting(state, "clawAgentGenerationApiInvocationsPrompt", undefined, undefined, true));
    const rawAgentIQReasoningPrompt = useSelector((state) => chatGPTReducer.getAgentIQReasoningPrompt(state, true));
    // Get the saved Blueprint Value
    const savedAgentIQReasoningPrompt = useSelector((state) => chatGPTReducer.getUseCaseSetting(state, "agentIQReasoningPrompt", undefined, undefined, true));
    const hasPromptChanged = (rawPrompt, savedPrompt) => {
        // undefined means no changes
        // or if someone copy pasted the same prompt, no changes happened
        if (rawPrompt === undefined) {
            return false;
        }
        if (savedPrompt && rawPrompt === savedPrompt) {
            return false;
        }
        return true;
    };
    const hasChanged = hasPromptChanged(rawClawAgentGenerationPrompt, savedClawAgentGenerationPrompt) ||
        hasPromptChanged(rawClawAgentGenerationCronJobsPrompt, savedClawAgentGenerationCronJobsPrompt) ||
        hasPromptChanged(rawClawAgentGenerationApiInvocationsPrompt, savedClawAgentGenerationApiInvocationsPrompt) ||
        hasPromptChanged(rawAgentIQReasoningPrompt, savedAgentIQReasoningPrompt);
    const handleSaveTemplate = async () => {
        setIsSaving(true);
        try {
            const savedId = await dispatch(chatGPTReducer.saveBlueprint(sTemplateName, selectedBlueprint?.wizard?.description));
            dispatch(chatGPTReducer.selectBlueprint(savedId));
        }
        catch (e) {
            console.log(e);
        }
        setIsSaving(false);
    };
    return (React.createElement("div", { className: styles.templateSelectionWrapper },
        React.createElement("div", { className: styles.templateSelectionItem },
            React.createElement("div", { className: styles.templateSelectionLabel }, retTitle),
            React.createElement("div", { className: styles.templateSelectionSelect, style: { marginLeft: "10px" } },
                React.createElement(BlueprintSelector, { menuPlacement: "bottom", skipSearchFilter: true, filterTypes: ["AGENT_C"] }))),
        hasChanged && (React.createElement("div", { className: styles.templateSelectionItem },
            React.createElement("div", { className: styles.templateSelectionLabel }, "Save Changes as "),
            React.createElement("div", { className: styles.templateSelectionInput },
                React.createElement("input", { className: styles.agentCTextInput, style: { padding: "6px 10px 5px", borderRadius: "3px" }, value: sTemplateName, onChange: (e) => setSTemplateName(e.currentTarget.value) })),
            React.createElement(Button, { type: "secondary", onClick: handleSaveTemplate, isLoading: isSaving }, "Save")))));
};
const GenerationSettings = ({ show }) => {
    const dispatch = useDispatch();
    const CLAW_PROMPTS = [
        {
            label: "General",
            value: "GENERAL"
        },
        {
            label: "Scheduled Tasks",
            value: "CRON_JOBS"
        },
        {
            label: "API Invocations",
            value: "API_INVOCATIONS"
        }
    ];
    const [selectedInstruction, setSelectedInstruction] = useState("GENERAL");
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const clawAgentGenerationPrompt = useSelector((state) => chatGPTReducer.getClawAgentGenerationPrompt(state, true, modelId));
    const resetClawAgentGenerationPrompt = () => dispatch(chatGPTReducer.resetClawAgentGenerationPrompt(modelId));
    const clawAgentGenerationCronJobsPrompt = useSelector((state) => chatGPTReducer.getClawAgentGenerationCronJobsPrompt(state, true, modelId));
    const resetClawAgentGenerationCronJobsPrompt = () => dispatch(chatGPTReducer.resetClawAgentGenerationCronJobsPrompt(modelId));
    const clawAgentGenerationApiInvocationsPrompt = useSelector((state) => chatGPTReducer.getClawAgentGenerationApiInvocationsPrompt(state, true, modelId));
    const resetClawAgentGenerationApiInvocationsPrompt = () => dispatch(chatGPTReducer.resetClawAgentGenerationApiInvocationsPrompt(modelId));
    return (React.createElement("div", { className: show ? styles.generationSettings + " " + styles.show : styles.generationSettings },
        React.createElement("div", { className: styles.generationSettingItem },
            React.createElement(TemplateSelection, null),
            React.createElement(ButtonGroup, null, CLAW_PROMPTS.map((o) => {
                return (React.createElement(Button, { active: o.value === selectedInstruction, onClick: () => {
                        setSelectedInstruction(o.value);
                    } }, o.label));
            }))),
        selectedInstruction === "GENERAL" ? (React.createElement("div", { className: styles.generationSettingItem },
            React.createElement("div", { className: styles.settingLabel, style: { display: "flex", justifyContent: "space-between" } },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", null, `${CHATAIBLE_AGENT_C.name} Generation Instructions`),
                    React.createElement(Tooltip, { overlay: React.createElement("div", { className: styles.generationToolTip },
                            React.createElement("div", { className: styles.generationToolTipText }, `These are the instructions sent to the selected model to generate the ${CHATAIBLE_AGENT_C.name} agent. The Scheduled Tasks and API Invocations will be created in a seperate step. This is just to create the general settings of the Agent. The following template variables can referenced for this step.`),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{CHAT_PROMPT}}"),
                                React.createElement("span", null, "The generation prompt from the user")),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{TOOL_OPTIONS}}"),
                                React.createElement("span", null, `The list of other agents the ${CHATAIBLE_AGENT_C.name} agent can call on`)),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{COMMUNICATION_OPTIONS}}"),
                                React.createElement("span", null, "The communication channels the agent will have access to in order to notify and interact with users")),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{SLACK_CHANNELS}}"),
                                React.createElement("span", null, "If one of the communication channels is Slack, these are the channels the agent has access to"))), tooltipIconStyleOverride: { marginTop: "-2px" }, trigger: ["click"] })),
                React.createElement(Button, { isSmall: true, type: "secondary", style: { marginLeft: "auto" }, onClick: () => resetClawAgentGenerationPrompt() },
                    React.createElement("img", { src: UndoArrowIcon, style: { width: "18px" } }))),
            React.createElement(TextInput, { className: styles.settingPrompt, style: { marginBottom: "0px" }, value: clawAgentGenerationPrompt ?? "", updateInstant: true, onChange: (val) => dispatch(chatGPTReducer.updateClawAgentGenerationPrompt(val, modelId)) }))) : selectedInstruction === "CRON_JOBS" ? (React.createElement("div", { className: styles.generationSettingItem },
            React.createElement("div", { className: styles.settingLabel, style: { display: "flex", justifyContent: "space-between" } },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", null, `${CHATAIBLE_AGENT_C.name} Scheduled Task Generation Instructions`),
                    React.createElement(Tooltip, { overlay: React.createElement("div", { className: styles.generationToolTip },
                            React.createElement("div", { className: styles.generationToolTipText }, `These are the instructions sent to the selected model to generate the Scheduled Tasks for the ${CHATAIBLE_AGENT_C.name} Agent. The following template variables can referenced for this step.`),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{CHAT_PROMPT}}"),
                                React.createElement("span", null, "The generation prompt from the user")),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{TOOL_OPTIONS}}"),
                                React.createElement("span", null, `The list of other agents the ${CHATAIBLE_AGENT_C.name} agent can call on`)),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{COMMUNICATION_OPTIONS}}"),
                                React.createElement("span", null, "The communication channels the agent will have access to in order to notify and interact with users")),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{SLACK_CHANNELS}}"),
                                React.createElement("span", null, "If one of the communication channels is Slack, these are the channels the agent has access to"))), tooltipIconStyleOverride: { marginTop: "-2px" }, trigger: ["click"] })),
                React.createElement(Button, { isSmall: true, type: "secondary", style: { marginLeft: "auto" }, onClick: () => resetClawAgentGenerationCronJobsPrompt() },
                    React.createElement("img", { src: UndoArrowIcon, style: { width: "18px" } }))),
            React.createElement(TextInput, { className: styles.settingPrompt, style: { marginBottom: "0px" }, value: clawAgentGenerationCronJobsPrompt ?? "", updateInstant: true, onChange: (val) => dispatch(chatGPTReducer.updateClawAgentGenerationCronJobsPrompt(val, modelId)) }))) : selectedInstruction === "API_INVOCATIONS" ? (React.createElement("div", { className: styles.generationSettingItem },
            React.createElement("div", { className: styles.settingLabel, style: { display: "flex", justifyContent: "space-between" } },
                React.createElement("div", { className: "flex items-center" },
                    React.createElement("div", null, `${CHATAIBLE_AGENT_C.name} API Invocation Generation Instructions`),
                    React.createElement(Tooltip, { overlay: React.createElement("div", { className: styles.generationToolTip },
                            React.createElement("div", { className: styles.generationToolTipText }, `These are the instructions sent to the selected model to generate the API Invocations for the ${CHATAIBLE_AGENT_C.name} Agent. The following template variables can referenced for this step.`),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{CHAT_PROMPT}}"),
                                React.createElement("span", null, "The generation prompt from the user")),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{TOOL_OPTIONS}}"),
                                React.createElement("span", null, `The list of other agents the ${CHATAIBLE_AGENT_C.name} agent can call on`)),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{COMMUNICATION_OPTIONS}}"),
                                React.createElement("span", null, "The communication channels the agent will have access to in order to notify and interact with users")),
                            React.createElement("div", { className: styles.generationToolTipText },
                                React.createElement("span", { style: { marginRight: "8px" } }, "{{SLACK_CHANNELS}}"),
                                React.createElement("span", null, "If one of the communication channels is Slack, these are the channels the agent has access to"))), tooltipIconStyleOverride: { marginTop: "-2px" }, trigger: ["click"] })),
                React.createElement(Button, { isSmall: true, type: "secondary", style: { marginLeft: "auto" }, onClick: () => resetClawAgentGenerationApiInvocationsPrompt() },
                    React.createElement("img", { src: UndoArrowIcon, style: { width: "18px" } }))),
            React.createElement(TextInput, { className: styles.settingPrompt, style: { marginBottom: "0px" }, value: clawAgentGenerationApiInvocationsPrompt ?? "", updateInstant: true, onChange: (val) => dispatch(chatGPTReducer.updateClawAgentGenerationApiInvocationsPrompt(val, modelId)) }))) : null));
};
const ModeSelection = ({ isManualAgent, setIsManualAgent, showButtonText }) => {
    return (React.createElement("div", null,
        React.createElement(ButtonGroup, null,
            React.createElement(Tooltip, { trigger: "hover", overlay: "Let Aible automatically set up your agent" },
                React.createElement(Button, { style: isManualAgent ? { color: "#333333" } : {}, onClick: () => setIsManualAgent(false), active: !isManualAgent, isSmall: true },
                    React.createElement("div", { className: "flex items-center" },
                        React.createElement("div", { className: "w-[24px]" },
                            React.createElement("img", { className: "w-[100%]", src: isManualAgent ? BoltIcon : BoltIconPurple })),
                        showButtonText && React.createElement("div", { className: "ml-[8px] pr-[4px]" }, "Automatic")))),
            React.createElement(Tooltip, { trigger: "hover", overlay: "Manually set up your agent" },
                React.createElement(Button, { style: isManualAgent ? {} : { color: "#333333" }, onClick: () => setIsManualAgent(true), active: isManualAgent, isSmall: true },
                    React.createElement("div", { className: "flex items-center" },
                        React.createElement("div", { className: "w-[24px]" },
                            React.createElement("img", { className: "w-[100%]", src: isManualAgent ? ScrewDriverWrenchIconPurple : ScrewDriverWrenchIcon })),
                        showButtonText && React.createElement("div", { className: "ml-[8px] pr-[4px]" }, "Manual")))))));
};
export const AgentC = ({ agent = undefined, setAgent, forceCronTest, forceAPITest, hasGeneratedAgent, isManualAgent, isMaxHeight, isFromChatGPT, setIsManualAgent, useCache, setUseCache, isTemplateView }) => {
    const dispatch = useDispatch();
    const [useGuardrails, setUseGuardrails] = useState(false);
    const [showToneSettings, setShowToneSettings] = useState(false);
    const [expandAllSettings, setExpandAllSettings] = useState(false);
    const agentIqBaseModel = useSelector((state) => chatGPTReducer.getAgentIQBaseModel(state));
    const [slackChannels, setSlackChannels] = useState([]);
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const agentIQReasoningPrompt = useSelector((state) => chatGPTReducer.getAgentIQReasoningPrompt(state, true, modelId));
    const selectedAgentIqBaseModel = useSelector((state) => agentIqBaseModel && !isNaN(Number(agentIqBaseModel))
        ? aiServiceReducer.getModelById(state, agentIqBaseModel)
        : undefined);
    const chatTone = useSelector((state) => chatGPTReducer.getChatTone(state));
    const chatTones = useSelector((state) => chatGPTReducer.getChatToneOptions(state));
    const savedToneId = agent?.chatOverrides?.chatTone;
    const foundToneValue = savedToneId && chatTones.find((v) => v.value === savedToneId)?.value;
    const guardrailsCheckboxRef = useRef(null);
    const selectedSandbox = useSelector((state) => chatGPTReducer.getSelectedSandbox(state));
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    // Using this useEffect to update tone to the saved tone on the claw agent
    useEffect(() => {
        if (foundToneValue && foundToneValue !== chatTone) {
            dispatch(chatGPTReducer.updateChatTone(foundToneValue));
        }
    }, []);
    // UseEffect and method to fetch/update the available slackChannels
    const fetchSlackTools = async () => {
        try {
            const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
            const tools = await factory.getCompletionClient().getTools();
            setSlackChannels(tools);
            console.log("what is slackChannels", tools);
        }
        catch (error) {
            console.error("Error fetching items:", error);
        }
    };
    useEffect(() => {
        fetchSlackTools();
    }, []);
    // Uncompressed memory option track if every cronJob has a tool with tool.id "14"
    // and adds or removes from each cronJob's blueprintOptions when checked/unchecked.
    // Our tool select has a filtered list and updates with the hidden tools when changed.
    const cronJobs = agent?.cronJobs ?? [];
    const hasUncompressedMemoryEnabled = cronJobs.every((job) => {
        const foundTelemtryTool = job?.blueprintOptions?.find((tool) => tool?.id === "14");
        return Boolean(foundTelemtryTool);
    });
    let isGuardrailsIndeterminate = false;
    if (useGuardrails) {
        aibleAnywhereReducer.CLAW_COLLECTION_ID_LOCATIONS.forEach((key) => {
            agent?.[key]?.forEach((cTask) => {
                cTask?.blueprintOptions?.forEach((bpOption) => {
                    const hasGuardrailOptions = dispatch((dispatch, getState) => {
                        return chatGPTReducer.getIsGuardrailsAllowedCTool(getState(), bpOption);
                    });
                    if (hasGuardrailOptions) {
                        if (!bpOption?.guardrails_config?.input_instructions || !bpOption?.guardrails_config?.output_instructions) {
                            isGuardrailsIndeterminate = true;
                        }
                    }
                });
            });
        });
    }
    useEffect(() => {
        if (guardrailsCheckboxRef.current) {
            const currentCheckbox = guardrailsCheckboxRef.current;
            currentCheckbox.indeterminate = isGuardrailsIndeterminate;
        }
    }, [isGuardrailsIndeterminate]);
    const handleUpdateUseGuardrails = (val) => {
        const retAgent = {
            ...agent
        };
        const guardrailsTaskKeys = aibleAnywhereReducer.CLAW_COLLECTION_ID_LOCATIONS;
        // toggle the guardrails for all tasks
        guardrailsTaskKeys.forEach((key) => {
            retAgent?.[key]?.forEach((cTask) => {
                if (cTask?.blueprintOptions?.length) {
                    cTask.blueprintOptions = cTask?.blueprintOptions?.map((bpOption) => {
                        const retOption = dispatch(aibleAnywhereReducer.modifyGuardrailSettingsOnTool(bpOption, val));
                        return retOption;
                    });
                }
            });
        });
        setUseGuardrails(val);
        setAgent(retAgent);
    };
    const toggleUncompressedMemory = () => {
        if (hasUncompressedMemoryEnabled) {
            const cronJobUpdate = cronJobs.map((job) => {
                const jobBlueprintOptions = job?.blueprintOptions ?? [];
                const jobBlueprintUpdate = jobBlueprintOptions?.filter((tool) => tool?.id !== "14");
                return {
                    ...job,
                    blueprintOptions: jobBlueprintUpdate
                };
            });
            const agentUpdate = {
                ...agent,
                cronJobs: cronJobUpdate
            };
            setAgent(agentUpdate);
        }
        else {
            const cronJobUpdate = cronJobs.map((job) => {
                const jobBlueprintOptions = [...(job?.blueprintOptions ?? [])];
                const foundTelemtryTool = jobBlueprintOptions?.find((tool) => tool?.id === "14");
                if (foundTelemtryTool) {
                    return job;
                }
                else {
                    jobBlueprintOptions.push({
                        id: "14",
                        blueprint_id: agent?.id
                    });
                    const jobUpdate = {
                        ...(job ?? []),
                        blueprintOptions: jobBlueprintOptions
                    };
                    return jobUpdate;
                }
            });
            const agentUpdate = {
                ...agent,
                cronJobs: cronJobUpdate
            };
            setAgent(agentUpdate);
        }
    };
    const isOpenShellAssistant = agent?.isAssistant;
    return (React.createElement("div", { className: agent?.id !== undefined ? styles.agentCSidePanelBody : styles.agentCModalBody, style: isMaxHeight ? { maxHeight: "100vh" } : {} },
        hasGeneratedAgent ? (React.createElement("div", { className: "flex items-center justify-between" },
            React.createElement("div", { className: "flex-1" },
                React.createElement("div", { className: "flex items-center mb-[12px]" },
                    React.createElement("div", { className: styles.generatedSuccessIconWrapper },
                        React.createElement("img", { src: CircleCheckIcon })),
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.generatedSuccessTitle }, "I have finished setting up your agent!"),
                        React.createElement("div", { className: styles.generatedSuccessSubtitle }, "Please review and approve to start using your agent")))),
            React.createElement("div", null,
                React.createElement(ToggleAllTaskSettingsButton, { expandAllSettings: expandAllSettings, setExpandAllSettings: setExpandAllSettings })))) : isManualAgent && setIsManualAgent ? (React.createElement("div", { className: "flex items-center justify-between mb-[10px]" },
            React.createElement(ModeSelection, { isManualAgent: isManualAgent, setIsManualAgent: setIsManualAgent, showButtonText: true }),
            React.createElement("div", null,
                React.createElement(ToggleAllTaskSettingsButton, { expandAllSettings: expandAllSettings, setExpandAllSettings: setExpandAllSettings })))) : (React.createElement(React.Fragment, null)),
        agent?.id !== undefined && !(isTemplateView && agent?.isEnabled !== true) && (React.createElement("div", { className: "flex items-end justify-between w-[100%] mb-[14px]" },
            React.createElement("div", { className: styles.agentCInput, style: { marginBottom: "0px" } },
                React.createElement("div", { className: styles.agentCInputBold }, "Enable Agent"),
                React.createElement(ButtonGroup, null,
                    React.createElement(Button, { onClick: (e) => setAgent({ ...agent, ["isEnabled"]: true }), active: agent?.isEnabled === true }, "Enabled"),
                    React.createElement(Button, { onClick: (e) => setAgent({ ...agent, ["isEnabled"]: false }), active: agent?.isEnabled !== true }, "Disabled"))),
            React.createElement("div", null,
                React.createElement(ToggleAllTaskSettingsButton, { expandAllSettings: expandAllSettings, setExpandAllSettings: setExpandAllSettings })))),
        React.createElement(ClawAgentDetails, { agent: agent, setAgent: setAgent, showToneSettings: showToneSettings, setShowToneSettings: setShowToneSettings, expandAllSettings: expandAllSettings, selectedAgentIqBaseModel: selectedAgentIqBaseModel, renderIndex: 1 }),
        !isOpenShellAssistant && (React.createElement(React.Fragment, null,
            React.createElement(ClawAgentMemory, { hasUncompressedMemoryEnabled: hasUncompressedMemoryEnabled, toggleUncompressedMemory: toggleUncompressedMemory, expandAllSettings: expandAllSettings, renderIndex: 2 }),
            React.createElement(ClawTaskItem, { type: "GUARDRAILS", renderIndex: 3, open: expandAllSettings },
                React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "This agent will safeguard output using:"),
                React.createElement("div", { className: styles.agentCMemory, style: { marginBottom: "6px" }, onClick: () => {
                        handleUpdateUseGuardrails(!useGuardrails);
                    } },
                    React.createElement("input", { type: "checkbox", className: styles.agentCSetupCheckbox, checked: useGuardrails === true, ref: guardrailsCheckboxRef, readOnly: true }),
                    React.createElement("div", null, "NVIDIA Nemo Guardrails")),
                React.createElement("div", { className: styles.agentCMemory, onClick: () => {
                        return;
                    } },
                    React.createElement("input", { type: "checkbox", className: styles.agentCSetupCheckbox, checked: false, readOnly: true, disabled: true }),
                    React.createElement("div", null, "Cisco AI Defense (Turned off in air-gapped mode)"))))),
        isFromChatGPT && selectedSandbox !== undefined && React.createElement(FlaggedNetworkRequests, { sandboxName: selectedSandbox?.name }),
        React.createElement(CronJobs, { agentC: agent, updateAgentC: (key, data) => {
                return setAgent({ ...agent, [key]: data });
            }, forceTest: forceCronTest, useGuardrails: useGuardrails, open: expandAllSettings, useCache: useCache, isManualAgent: isManualAgent, slackChannels: slackChannels, fetchSlackTools: fetchSlackTools, isTemplateView: isTemplateView }),
        isEnabled("aible-claw-api-invocations") && (React.createElement(APIInvocations, { agentC: agent, updateAgentC: (key, data) => {
                return setAgent({ ...agent, [key]: data });
            }, useGuardrails: useGuardrails, forceTest: forceAPITest, open: expandAllSettings, useCache: useCache, isManualAgent: isManualAgent, slackChannels: slackChannels, fetchSlackTools: fetchSlackTools, isTemplateView: isTemplateView })),
        React.createElement("div", { style: { marginTop: "10px", display: "flex", alignItems: "center", justifyContent: "space-between" } },
            React.createElement("span", null, "Reduce costs by showing cached responses to matching questions"),
            React.createElement(LabeledToggle, { style: { display: "block" }, checked: useCache, onChange: () => setUseCache(!useCache), isAibleColors: true }))));
};
export const ClawAgentDetails = ({ agent, setAgent, showToneSettings, setShowToneSettings, expandAllSettings, selectedAgentIqBaseModel, renderIndex }) => {
    const dispatch = useDispatch();
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const agentIQReasoningPrompt = useSelector((state) => chatGPTReducer.getAgentIQReasoningPrompt(state, true, modelId));
    return (React.createElement(ClawTaskItem, { type: "DETAILS", renderIndex: renderIndex, open: expandAllSettings },
        React.createElement("div", { className: styles.agentCInput },
            React.createElement("div", { className: styles.agentCInputBold }, "Agent name"),
            React.createElement("input", { className: styles.agentCTextInput, value: agent?.name, onChange: (e) => setAgent({ ...agent, ["name"]: e.currentTarget.value }) })),
        React.createElement("div", { className: styles.agentCInput },
            React.createElement("div", { className: styles.agentCInputBold }, "Agent description"),
            React.createElement("input", { className: styles.agentCTextInput, value: agent?.description, onChange: (e) => setAgent({ ...agent, ["description"]: e.currentTarget.value }) })),
        React.createElement("div", { className: styles.agentCInput },
            React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Core operating principles"),
            React.createElement("div", { className: styles.agentCInput, style: { marginBottom: "10px" } }, "This defines how the agent uses tools and data to accomplish tasks"),
            React.createElement(TemplateSelection, { title: "Use Principles from" }),
            React.createElement("textarea", { placeholder: "Core principles", className: styles.aaTextArea, value: agentIQReasoningPrompt ?? "", onChange: (val) => dispatch(chatGPTReducer.updateAgentIQReasoningPrompt(val.currentTarget.value, modelId)) })),
        React.createElement("div", { className: styles.agentCInput },
            React.createElement("div", { className: styles.agentCInputBold }, "How it responds (soul/tone)"),
            React.createElement("div", { className: "flex items-center" },
                React.createElement("div", { className: "w-[100%] mr-[10px] flex-1" },
                    React.createElement(ToneSelector, { menuPlacement: "bottom" })),
                React.createElement("div", null,
                    React.createElement(Button, { type: "secondary", onClick: () => setShowToneSettings(!showToneSettings) },
                        React.createElement("img", { src: EditIcon, style: { width: "18px" } }))))),
        React.createElement("div", null,
            React.createElement(ToneSettings, { onlyViewSelectedTonePrompt: !showToneSettings, selectedTonePromptModelOverride: selectedAgentIqBaseModel?.external_id }))));
};
export const ClawAgentMemory = ({ hasUncompressedMemoryEnabled, toggleUncompressedMemory, expandAllSettings, renderIndex }) => {
    const dispatch = useDispatch();
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const agentIQReasoningPrompt = useSelector((state) => chatGPTReducer.getAgentIQReasoningPrompt(state, true, modelId));
    return (React.createElement(ClawTaskItem, { type: "MEMORY", renderIndex: renderIndex, open: expandAllSettings },
        React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Memories Permissions"),
        React.createElement("div", { style: { marginBottom: "4px" } }, `${CHATAIBLE_AGENT_C.name} can read and write to the memory. All tools and agents it calls can only write to the memory.`),
        React.createElement("div", { className: styles.agentCMemory, onClick: () => {
                toggleUncompressedMemory();
            } },
            React.createElement("input", { type: "checkbox", className: styles.agentCSetupCheckbox, checked: hasUncompressedMemoryEnabled, readOnly: true }),
            React.createElement("div", null, "Agent specific memory (uncompressed)"))));
};
const ToggleAllTaskSettingsButton = ({ expandAllSettings, setExpandAllSettings }) => {
    // Currently disabling or hiding for now
    return null;
    return (React.createElement(Button, { className: styles.expandAllSettingsButton, onClick: () => {
            setExpandAllSettings(!expandAllSettings);
        }, active: expandAllSettings }, "Settings"));
};
export const ClawTaskItem = ({ type, defaultOpen, open, children, renderIndex, titleOverride, headerActions, disabled }) => {
    const [internalOpen, updateInternalOpen] = useState(defaultOpen);
    useEffect(() => {
        if (open !== undefined && open !== internalOpen) {
            updateInternalOpen(open);
        }
    }, [open]);
    return (React.createElement(Accordion, { show: internalOpen, header: React.createElement("div", null,
            React.createElement(ClawTaskHeaderItem, { type: type, listText: renderIndex !== undefined ? `${CHATAIBLE_AGENT_C.name.toUpperCase()} SETUP ${renderIndex}` : undefined, titleOverride: titleOverride, headerActions: headerActions })), onToggle: () => updateInternalOpen(!internalOpen), hideIcon: true, className: styles.clawTaskItemAccordion, disabled: disabled },
        React.createElement("div", { className: styles.clawTaskItemContainer }, children)));
};
const HEADER_ITEM_TYPES = {
    DETAILS: {
        id: "DETAILS",
        title: "Agent Role and Soul",
        description: "Generating the Agent soul description and name based on the user prompt.",
        image: CompassTaskIcon
    },
    MEMORY: {
        id: "MEMORY",
        title: "Agent Memory",
        description: "Configuring memory so the agent will have necessary context for all required tasks.",
        image: MemoryTaskIcon
    },
    GUARDRAILS: {
        id: "GUARDRAILS",
        title: "Guardrails",
        description: "Adding guardrails to ensure responses avoid using or generating malicious, protected, or policy-restricted content.",
        image: ShieldTaskIcon
    },
    COMMUNICATION: {
        id: "COMMUNICATION",
        title: "Communication Method",
        description: "Determining how the agent communicates its results to you.",
        image: ""
    },
    TASK: {
        id: "TASK",
        title: "Agent Task",
        description: "Agent Tasks on schedule/heartbeat.",
        image: AgentTaskIcon
    },
    API: {
        id: "API",
        title: "API Invocation",
        description: "API Invocations.",
        image: AgentTaskIcon
    },
    FLAGGED_NETWORK_REQUESTS: {
        id: "FLAGGED_NETWORK_REQUESTS",
        title: "Flagged Network Requests",
        description: "Your agent will request permission for any new tools. If you reject it the agent will attempt to complete the task without the requested tool.",
        image: FlaggedRequestsBellIcon
    },
    PERMISSION: {
        id: "PERMISSION",
        title: "Agent Permissions & Security",
        description: "Read-write access, read-only files, standard security enforcement.",
        image: ShieldTaskIcon
    },
    TOOLS_INTEGRATIONS: {
        id: "TOOLS_INTEGRATIONS",
        title: "Tools & Integrations",
        description: "View and edit available tools and policies.",
        image: ToolsIcon
    },
    AIBLE_SKILL: {
        id: "AIBLE_SKILL",
        title: "Choose your AibleClaw Setup",
        description: "",
        image: AibleIcon
    },
    SANDBOX_WORK_LIST: {
        id: "SANDBOX_WORK_LIST",
        title: "Save Reusable Agent Templates",
        description: "Save your work as a deterministic agent that can be shared and runs consistently",
        image: AibleIcon
    },
    API_KEY: {
        id: "API_KEY",
        title: "Enter API Key",
        description: "Enter API key to allow use of this service. Must create a new Sandbox for this to apply!",
        image: AibleIcon
    },
    REQUIRED_API_KEYS: {
        id: "REQUIRED_API_KEYS",
        title: "Tools that Require API Keys",
        description: "Additional tools that require API keys to enable.",
        image: ApiKeysIcon
    },
    AIBLE_TOOLS: {
        id: "AIBLE_TOOLS",
        title: "Aible Tools",
        description: "Enable or disable Aible tools for this OpenClaw sandbox.",
        image: ToolsIcon
    },
    SKILLS: {
        id: "SKILLS",
        title: "Skills",
        description: "List of available OpenClaw skills.",
        image: SkillsLightbulbIcon
    },
    USAGE_STATS: {
        id: "USAGE_STATS",
        title: "Usage Stats",
        description: "An overview of the activity and token usage for this agent.",
        image: UsageStats
    },
    CRON_JOBS: {
        id: "CRON_JOBS",
        title: "Cron Jobs",
        description: "List of Cron Jobs",
        image: AibleIcon
    },
    AGENT_DEFINITION: {
        id: "AGENT_DEFINITION",
        title: "Agent Definition",
        description: "Shape how the agent responds and choose how it can use approved tools and agents in this workspace.",
        image: CompassTaskIcon
    },
    AGENT_CHANNELS: {
        id: "AGENT_CHANNELS",
        title: "Agent Messaging Channels",
        description: "Choose where this agent can communicate with you.",
        image: MessageBotIcon
    },
    AGENT_PROVIDERS: {
        id: "AGENT_PROVIDERS",
        title: "Agent Credentials",
        description: "Give the agent secure access to credentials.",
        image: ApiKeysIcon
    }
};
const ClawTaskHeaderItem = ({ type = undefined, listText, titleOverride, headerActions, descriptionOverride }) => {
    if (!type)
        return null;
    const retTypeItem = HEADER_ITEM_TYPES[type];
    if (!retTypeItem)
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex items-center justify-between w-[100%]" },
            React.createElement("div", { className: styles.cTaskHeaderIconWrapper },
                React.createElement("img", { src: retTypeItem.image })),
            React.createElement("div", { className: "flex flex-col flex-1 w-[100%]" },
                listText ? React.createElement("div", { className: styles.clawHeaderSystemText }, listText) : null,
                React.createElement("div", { className: styles.clawHeaderTitleText }, titleOverride ? titleOverride : retTypeItem?.title)),
            headerActions && React.createElement("div", null, headerActions)),
        React.createElement("div", { className: styles.clawHeaderDescriptionText }, descriptionOverride ? descriptionOverride : retTypeItem?.description)));
};
const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
            const date = new Date();
            date.setHours(hour, minute, 0, 0);
            const label = date.toLocaleTimeString([], {
                hour: "numeric",
                minute: "2-digit"
            });
            options.push({
                value: `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`,
                label: `${label} every day`
            });
        }
    }
    return options;
};
const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const generateIntervalOptions = () => {
    const intervals = [];
    // Minutes
    [1, 5, 15, 30].forEach((m) => {
        intervals.push({
            value: m * MINUTE,
            label: `Every ${m} minute${m > 1 ? "s" : ""}`
        });
    });
    // Hours
    [1, 2, 4, 6, 12, 24].forEach((h) => {
        intervals.push({
            value: h * HOUR,
            label: h === 24 ? "Once a day" : `Every ${h} hour${h > 1 ? "s" : ""}`
        });
    });
    // Days
    [2, 3].forEach((d) => {
        intervals.push({
            value: d * DAY,
            label: `Every ${d} days`
        });
    });
    // Weekly
    intervals.push({
        value: WEEK,
        label: "Once a week"
    });
    return intervals;
};
const intervalOptions = generateIntervalOptions();
export const CronJobs = ({ agentC, updateAgentC, forceTest, useGuardrails, open, useCache, disableTests, hideCommunicationChannels, hideCreate, hideDelete, hideTools, hideSetupStepDisplay, isManualAgent, slackChannels, fetchSlackTools, selectWorkflowAgentOptions, isTemplateView }) => {
    const dispatch = useDispatch();
    const cLoading = useSelector((state) => globalReducer.getClawActivityLoad(state, agentC?.id));
    const cronJobs = agentC?.cronJobs ?? [];
    const initCronJob = {
        prompt: undefined
    };
    const updateCronJob = (cronJob, index) => {
        const retCronJobs = cronJobs.map((cj, i) => (i === index ? cronJob : cj));
        return updateAgentC("cronJobs", retCronJobs);
    };
    const deleteCronJob = (index) => {
        const retCronJobs = [...(cronJobs ?? [])];
        retCronJobs.splice(index, 1);
        return updateAgentC("cronJobs", retCronJobs);
    };
    const testCronJob = async (cronJob, index) => {
        const sAgent = await dispatch(aibleAnywhereReducer.saveAibleAnywhere(agentC, agentC?.name, false));
        let retBlueprintOptions = [...(cronJob?.blueprintOptions ?? [])];
        if (aibleAnywhereReducer.shouldInjectSlackTool(cronJob)) {
            retBlueprintOptions.push({
                id: 11,
                third_party_tool_id: cronJob?.slackChannel?.value,
                name: "post_report_to_channel"
            });
        }
        dispatch(chatGPTReducer.updateAgentIQTools(retBlueprintOptions));
        dispatch(chatGPTReducer.init());
        if (cronJob?.executionMetadata?.execution_id !== undefined) {
            await dispatch(aibleAnywhereReducer.checkUpdateExecutionMetadata(cronJob?.executionMetadata?.execution_id, cronJob?.executionMetadata?.data?.name, cronJob?.executionMetadata?.data?.description, cronJob?.executionMetadata?.data?.steps, cronJob?.executionMetadata?.data?.tool_list));
        }
        dispatch(chatGPTReducer.handleAgentIQ(cronJob?.prompt, false, "reasoning", cronJob?.executionMetadata?.execution_id, sAgent?.id, retBlueprintOptions, useCache));
    };
    const isAsking = useSelector((state) => chatGPTReducer.getIsAsking(state));
    const blueprintOptions = useSelector((state) => chatGPTReducer.getAgentCTools(state, agentC));
    const STEP_TYPE_OPTIONS = [
        { label: "NLQ", value: "dataset_nlq" },
        { label: "Document Summary", value: "summarize_document" },
        { label: "Analytics", value: "analyze_dataset" },
        { label: "Prediction", value: "prediction_tool" },
        //{ label: "Create Derived Feature", value: "create_derived_feature" },
        //{ label: "Dataset Join", value: "perform_left_join" },
        { label: "Search The Web", value: "web_researcher_tool" }
    ];
    const blueprints = useSelector((state) => viewReducer.getChatBlueprints(state));
    const agentIQToolOptions = useSelector((state) => chatGPTReducer.getAgentIQToolOptions(agentC));
    const nexts = useSelector((state) => nextReducer.getBase(state));
    const projectOptions = nexts
        ? Object.keys(nexts)
            .filter((n) => nexts[n]?.projectId !== undefined)
            .map((n) => ({
            label: nexts[n]?.reportLabel,
            value: nexts[n]?.projectId
        }))
        : [];
    const isOpenShellAssistant = agentC?.isAssistant;
    return (React.createElement("div", { className: styles.agentCTrigger },
        !hideCreate ? (React.createElement("div", { className: "flex items-center mb-[8px]" },
            React.createElement("div", { className: styles.agentCInputBold }, `${cronJobs.length > 0 ? cronJobs.length + " " : ""}Scheduled Wakeup${cronJobs.length <= 1 ? "" : "s"} (Cron) / Heartbeats`),
            React.createElement(Button, { style: { fontSize: "16px", marginLeft: "10px" }, onClick: () => updateAgentC("cronJobs", [...(cronJobs ?? []), { ...initCronJob }]) }, "Add"))) : null,
        cronJobs.map((cronJob, index) => {
            /* Hiding the memory tool from this select and still preserving it in the cronJob, also prevents task settings from showing for the memory tool */
            const toolSelectVal = (cronJob?.blueprintOptions ?? []).filter((option) => !CLAW_HIDDEN_TOOLS.includes(option?.id));
            const readableCronText = cronJob?.cron_expr && cronstrue.toString(cronJob?.cron_expr, { verbose: true });
            const disableTest = cLoading || cronJob?.blueprintOptions === undefined || cronJob?.blueprintOptions?.length === 0;
            return (React.createElement(CronJobTaskItem, { key: "cronjob_" + index, open: open, renderIndex: hideSetupStepDisplay ? undefined : index, headerActions: React.createElement("div", null,
                    !disableTests && (React.createElement(Button, { className: styles.cronJobTaskAction, onClick: (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            return forceTest !== undefined ? forceTest(cronJob, index) : testCronJob(cronJob, index);
                        }, disabled: disableTest, isSmall: true, isLoading: isAsking }, "Test")),
                    !hideDelete ? (React.createElement(Button, { className: styles.cronJobTaskAction, onClick: () => deleteCronJob(index), isSmall: true }, "Delete")) : null), descriptionOverride: `${readableCronText ? `${readableCronText}:` : ""} ${cronJob?.prompt ?? ""}` },
                React.createElement("div", { className: styles.agentCJob },
                    React.createElement("div", { className: styles.agentCJob },
                        React.createElement("div", { className: styles.agentCJobHeader },
                            React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Scheduled Wakeup: " + (index + 1))),
                        React.createElement(CronExpressionInput, { value: cronJob?.cron_expr, onChange: (cron_expr) => updateCronJob({ ...cronJob, cron_expr: cron_expr }, index) }),
                        React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px", marginBottom: "16px" } },
                            React.createElement("div", { className: styles.agentCInputBold }, "Timezone"),
                            React.createElement("div", { className: styles.agentCWrapperWithBorder },
                                React.createElement(TimezoneInput, { value: cronJob.timezone ?? "UTC", onChange: (timezone) => updateCronJob({ ...cronJob, timezone: timezone }, index), menuPlacement: "top" }))),
                        React.createElement("div", { className: styles.agentCInput },
                            React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Prompt"),
                            React.createElement("textarea", { placeholder: "Instructions for schedule", className: styles.aaTextArea, value: cronJob?.prompt, onChange: (val) => {
                                    updateCronJob({ ...cronJob, prompt: val.currentTarget.value }, index);
                                } })),
                        hideTools ? null : cronJob?.executionMetadata !== undefined ? (React.createElement("div", null,
                            React.createElement("div", { className: styles.agentCInputBold }, "Agent Steps "),
                            (cronJob?.executionMetadata?.data?.steps ?? []).map((s, i) => {
                                const foundToolId = agentIQToolOptions.find((t) => t?.value === s?.tool_name);
                                const foundTool = foundToolId === undefined
                                    ? (cronJob?.executionMetadata?.data?.tool_list ?? []).find((t) => t.name === s?.tool_name)
                                    : (cronJob?.executionMetadata?.data?.tool_list ?? []).find((t) => Number(t.id) === Number(foundToolId?.id));
                                const foundBlueprint = (blueprints ?? []).find((b) => b?.id === foundTool?.blueprint_id);
                                return (React.createElement("div", { className: styles.agentCStep },
                                    React.createElement("div", { className: styles.agentBackendTool },
                                        React.createElement("div", { className: styles.agentCInputBold }, "Step Type"),
                                        React.createElement("div", { className: styles.aaSelectOption },
                                            React.createElement(Select, { options: STEP_TYPE_OPTIONS, placeholder: "Select Step Type", value: s?.tool_name !== undefined
                                                    ? STEP_TYPE_OPTIONS.find((o) => o?.value === s?.tool_name)
                                                    : undefined, onChange: (val) => updateCronJob({
                                                    ...cronJob,
                                                    executionMetadata: {
                                                        ...(cronJob?.executionMetadata ?? {}),
                                                        data: {
                                                            ...(cronJob?.executionMetadata?.data ?? {}),
                                                            steps: (cronJob?.executionMetadata?.data?.steps ?? []).map((step, si) => si === i ? { ...s, tool_name: val?.value } : step)
                                                        }
                                                    }
                                                }, index) }))),
                                    s?.tool_name === "dataset_nlq" || s?.tool_name === "analyze_dataset" ? (React.createElement("div", null,
                                        React.createElement("div", { className: styles.agentBackendTool },
                                            React.createElement("div", { className: styles.agentCInputBold }, "Dataset"),
                                            React.createElement(DatasetSelector, { datasetId: s?.input_args?.dataset_id, onChange: (val) => {
                                                    updateCronJob({
                                                        ...cronJob,
                                                        executionMetadata: {
                                                            ...(cronJob?.executionMetadata ?? {}),
                                                            data: {
                                                                ...(cronJob?.executionMetadata?.data ?? {}),
                                                                steps: (cronJob?.executionMetadata?.data?.steps ?? []).map((step, si) => si === i
                                                                    ? { ...s, input_args: { ...(s?.input_args ?? {}), dataset_id: val } }
                                                                    : step)
                                                            }
                                                        }
                                                    }, index);
                                                }, allowAllDatasets: s?.tool_name === "dataset_nlq", hideJustChat: true, allowOutcomeSelect: false, allowUpload: false })),
                                        React.createElement("div", { className: styles.agentBackendTool },
                                            React.createElement("div", { className: styles.agentCInputBold }, "Agent Template"),
                                            React.createElement(BlueprintSelector, { onChange: (val) => {
                                                    updateCronJob({
                                                        ...cronJob,
                                                        executionMetadata: {
                                                            ...(cronJob?.executionMetadata ?? {}),
                                                            data: {
                                                                ...(cronJob?.executionMetadata?.data ?? {}),
                                                                tool_list: (cronJob?.executionMetadata?.data?.tool_list ?? []).map((tool) => tool?.id === foundTool?.id
                                                                    ? { ...tool, blueprint_id: val?.value }
                                                                    : tool)
                                                            }
                                                        }
                                                    }, index);
                                                }, value: foundBlueprint?.id })))) : s?.tool_name === "prediction_tool" ? (React.createElement("div", null,
                                        React.createElement("div", { className: styles.agentCInputBold }, "Project (Model)"),
                                        React.createElement("div", { className: styles.aaSelectOption },
                                            React.createElement(Select, { options: projectOptions, placeholder: "Select Model", value: s?.model_id !== undefined
                                                    ? projectOptions?.find((d) => Number(d.value) === s?.model_id)
                                                    : undefined, onChange: (val) => {
                                                    updateCronJob({
                                                        ...cronJob,
                                                        executionMetadata: {
                                                            ...(cronJob?.executionMetadata ?? {}),
                                                            data: {
                                                                ...(cronJob?.executionMetadata?.data ?? {}),
                                                                steps: (cronJob?.executionMetadata?.data?.steps ?? []).map((step, si) => si === i
                                                                    ? {
                                                                        ...s,
                                                                        input_args: { ...(s?.input_args ?? {}), model_id: val?.value }
                                                                    }
                                                                    : step)
                                                            }
                                                        }
                                                    }, index);
                                                } })))) : (React.createElement("div", null))));
                            }))) : (React.createElement("div", { className: "mt-[-10px] mb-[20px] w-[100%] flex flex-col" },
                            React.createElement("div", { className: styles.agentCInput, style: { marginTop: "-10px", width: "100%" } },
                                React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Agents or tools it can use"),
                                React.createElement("div", { className: "w-[100%]" },
                                    React.createElement(Select, { isMulti: true, options: blueprintOptions, value: toolSelectVal, onChange: (value) => {
                                            const updatedOptions = dispatch(aibleAnywhereReducer.validateClawToolSelection(value, cronJob?.blueprintOptions, useGuardrails));
                                            updateCronJob({ ...cronJob, blueprintOptions: updatedOptions }, index);
                                        }, placeholder: "Select agents and tools..." }))),
                            (toolSelectVal ?? []).map((bp, toolIndex) => (React.createElement(TaskSettings, { key: `cronJob_id_${bp?.id}_val_${bp?.value}_${index}`, agent: agentC, task: cronJob, index: index, tool: bp, toolIndex: toolIndex, updateTask: updateCronJob, isTemplateView: isTemplateView }))),
                            !isOpenShellAssistant && !selectWorkflowAgentOptions && !hideCommunicationChannels && (React.createElement(TaskCommunicationOptions, { task: cronJob, updateTask: updateCronJob, index: index, slackChannels: slackChannels, fetchSlackTools: fetchSlackTools })))),
                        selectWorkflowAgentOptions && (React.createElement("div", { className: "mt-[-10px] mb-[20px] w-[100%] flex flex-col" },
                            React.createElement("div", { className: styles.agentCInput, style: { marginTop: "-10px", width: "100%" } },
                                React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Agents or tools it can use"),
                                React.createElement("div", { className: "w-[100%]" },
                                    React.createElement(Select, { isMulti: true, options: selectWorkflowAgentOptions, value: selectWorkflowAgentOptions.filter((o) => (cronJob?.workflowOptions ?? []).includes(o?.value)), onChange: (selectOptions) => {
                                            const updatedCronJob = {
                                                ...cronJob,
                                                workflowOptions: selectOptions.map((o) => o.value)
                                            };
                                            updateCronJob(updatedCronJob, index);
                                        }, placeholder: "Select agents and tools..." })))))))));
        })));
};
const TaskCommunicationOptions = ({ task, updateTask, index, slackChannels, fetchSlackTools }) => {
    const dispatch = useDispatch();
    const communicationOptions = useSelector((state) => chatGPTReducer.getAgentCCommunicationOptions(state));
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const [isAddingChannel, updateIsAddingChannel] = useState(false);
    const [isDeletingChannel, updateIsDeletingChannel] = useState(false);
    const [showAddChannel, updateShowAddChannel] = useState(false);
    const [slackWebhookUrl, updateSlackWebhookUrl] = useState("");
    const [slackChannelId, updateSlackChannelId] = useState("");
    const [slackWorkspaceId, updateSlackWorkspaceId] = useState("");
    const [connectErrorText, updateConnectErrorText] = useState("");
    const disableConnect = !slackWebhookUrl?.length || !slackChannelId?.length || !slackWorkspaceId?.length;
    const disableDelete = task?.slackChannel?.value === undefined || task?.slackChannel?.value === null;
    if (!isEnabled("aible-claw-external-communication-options")) {
        return null;
    }
    const resetAddChannel = () => {
        updateShowAddChannel(false);
        updateSlackWorkspaceId("");
        updateSlackChannelId("");
        updateSlackWebhookUrl("");
        updateConnectErrorText("");
    };
    const handleConnectSlackChannel = async () => {
        if (disableConnect) {
            return;
        }
        updateIsAddingChannel(true);
        updateConnectErrorText("");
        try {
            const addToolRequest = {
                type: "slack",
                webhook_url: slackWebhookUrl,
                channel_id: slackChannelId,
                workspace_id: slackWorkspaceId
            };
            const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
            const toolsRes = await factory.getCompletionClient().addTool(addToolRequest);
            if ("error" in toolsRes) {
                throw { message: toolsRes.message };
            }
            if (fetchSlackTools !== undefined) {
                await fetchSlackTools();
            }
            updateIsAddingChannel(false);
            const newSlackChannel = {
                label: toolsRes?.config?.channel_id,
                value: toolsRes?.id
            };
            updateTask({ ...task, slackChannel: newSlackChannel }, index);
            resetAddChannel();
        }
        catch (error) {
            console.log("Error connecting slack channel:", error);
            let errorMsg = "Could not connect slack channel";
            if ("message" in error) {
                console.log("errorMessage: ", error?.message);
                if ("message" in error.message) {
                    errorMsg = errorMsg + ` ${error?.message.message}`;
                }
                else {
                    errorMsg = errorMsg + ` ${error?.message}`;
                }
            }
            updateConnectErrorText(errorMsg);
        }
    };
    const handleDeleteSlackChannel = async (slackChannel) => {
        if (slackChannel?.value === undefined) {
            return;
        }
        resetAddChannel();
        updateIsDeletingChannel(true);
        updateConnectErrorText("");
        try {
            const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
            await factory.getCompletionClient().deleteTool(slackChannel?.value);
            const taskUpdate = {
                ...task
            };
            if (taskUpdate?.slackChannel !== undefined) {
                delete taskUpdate.slackChannel;
            }
            updateTask(taskUpdate, index);
        }
        catch (error) {
            console.error("Error deleting slack channel:", error);
            updateConnectErrorText(`Could not delete slack channel: ${error}`);
        }
        finally {
            if (fetchSlackTools !== undefined) {
                await fetchSlackTools();
            }
        }
        updateIsDeletingChannel(false);
    };
    const showTestDeleteButton = true;
    const slackChannelOptions = (slackChannels ?? []).map((sc) => ({
        label: sc?.config?.channel_id,
        value: sc?.id
    }));
    const foundSlackChannel = slackChannelOptions?.find((o) => o?.value === task?.slackChannel?.value);
    return (React.createElement("div", { className: styles.agentCInput },
        React.createElement("div", { className: styles.agentCInputBold }, "Communication channels it can write to"),
        React.createElement(Select, { isMulti: true, options: communicationOptions, value: task?.communicationOptions, onChange: (value) => updateTask({ ...task, communicationOptions: value }, index), placeholder: "Select communication channels..." }),
        React.createElement("div", { style: { height: "10px" } }),
        task?.communicationOptions?.find((c) => c?.value === "Slack") && (React.createElement("div", null,
            React.createElement("div", { className: "flex flex-col mt-[10px]" },
                React.createElement("div", null, "Which Slack channel should this agent post to?"),
                React.createElement("div", { className: "flex items-center mb-[20px] w-[100%]" },
                    React.createElement("div", { className: "w-[100%] mr-[10px] flex-1" },
                        React.createElement(Select, { options: slackChannelOptions, value: foundSlackChannel ?? null, onChange: (val) => updateTask({ ...task, slackChannel: val }, index), placeholder: "Select slack channel" })),
                    React.createElement(Button, { onClick: () => {
                            if (!showAddChannel) {
                                updateShowAddChannel(true);
                            }
                            else {
                                resetAddChannel();
                            }
                        } }, !showAddChannel ? "Add Channel" : "Cancel"),
                    showTestDeleteButton && task?.slackChannel !== undefined && (React.createElement(Button, { onClick: () => {
                            handleDeleteSlackChannel(task?.slackChannel);
                        }, isLoading: isDeletingChannel, style: { marginLeft: "4px" }, disabled: disableDelete }, "Delete Selected Channel")))),
            showAddChannel && (React.createElement("div", { className: "mb-[36px]" },
                React.createElement("div", { className: styles.addSlackChannelInputContainer },
                    React.createElement("div", { className: styles.addSlackChannelInputWrapper },
                        React.createElement("div", null, "Workspace ID"),
                        React.createElement("input", { className: styles.agentCTextInput, value: slackWorkspaceId, onChange: (e) => updateSlackWorkspaceId(e.currentTarget.value), disabled: isAddingChannel })),
                    React.createElement("div", { className: styles.addSlackChannelInputWrapper },
                        React.createElement("div", null, "Channel ID"),
                        React.createElement("input", { className: styles.agentCTextInput, value: slackChannelId, onChange: (e) => updateSlackChannelId(e.currentTarget.value), disabled: isAddingChannel })),
                    React.createElement("div", { className: styles.addSlackChannelInputWrapper },
                        React.createElement("div", null, "Webhook URL"),
                        React.createElement("input", { className: styles.agentCTextInput, value: slackWebhookUrl, onChange: (e) => updateSlackWebhookUrl(e.currentTarget.value), disabled: isAddingChannel })),
                    React.createElement(Button, { onClick: () => {
                            handleConnectSlackChannel();
                        }, isLoading: isAddingChannel, disabled: disableConnect }, "Connect")),
                connectErrorText?.length > 0 && React.createElement("div", { className: styles.slackConnectErrorText }, connectErrorText))),
            React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
                React.createElement("div", null, "Describe how you want the Agent to communicate on the channel"),
                React.createElement("textarea", { placeholder: "Instructions for reporting", className: styles.aaTextArea, value: task?.slackChannel?.description, onChange: (val) => updateTask({
                        ...task,
                        slackChannel: {
                            ...(task?.slackChannel ?? {}),
                            description: val?.currentTarget?.value
                        }
                    }, index) })))),
        task?.communicationOptions?.find((c) => c?.value === "SMS") && (React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
            React.createElement("div", null, "What phone number should I message with updates?"),
            React.createElement("input", { className: styles.agentCTextInput, value: task?.phoneNumber, onChange: (e) => updateTask({ ...task, phoneNumber: e.currentTarget.value }, index) })))));
};
const CronJobTaskItem = ({ defaultOpen, open, children, renderIndex, headerActions, descriptionOverride, type, agent }) => {
    const [internalOpen, updateInternalOpen] = useState(defaultOpen);
    const retType = type ?? "TASK";
    useEffect(() => {
        if (open !== undefined && open !== internalOpen) {
            updateInternalOpen(open);
        }
    }, [open]);
    let cronListText = `${CHATAIBLE_AGENT_C.name.toUpperCase()} SETUP ${renderIndex !== undefined ? renderIndex + 4 : ""}`;
    let cronTitleText = "Agent Task";
    if (type === "API" && agent) {
        const cronJobLength = agent?.cronJobs?.length ?? 0;
        cronListText = `${CHATAIBLE_AGENT_C.name.toUpperCase()} SETUP ${renderIndex !== undefined ? renderIndex + 4 + cronJobLength : ""}`;
        cronTitleText = "API Invocation";
    }
    return (React.createElement(Accordion, { show: internalOpen, header: React.createElement("div", { className: "w-[100%]" },
            React.createElement(ClawTaskHeaderItem, { type: retType, listText: cronListText, titleOverride: `${cronTitleText} ${renderIndex !== undefined ? renderIndex + 1 : ""}`, headerActions: headerActions, descriptionOverride: descriptionOverride })), onToggle: () => updateInternalOpen(!internalOpen), hideIcon: true, className: styles.clawTaskItemAccordion },
        React.createElement("div", { className: styles.clawTaskItemContainer }, children)));
};
const TaskSettings = ({ agent, task, index, tool, toolIndex, updateTask, isTemplateView }) => {
    const dispatch = useDispatch();
    const isGuardrailsAllowedCTool = useSelector((state) => chatGPTReducer.getIsGuardrailsAllowedCTool(state, tool));
    const defaultToolText = tool?.id ? AGENTIQ_TASK_INSTRUCTIONS[String(tool.id)] : "";
    const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const isBackendStepByStepTool = tool?.id === 9;
    const backendStepAgent = isBackendStepByStepTool && tool?.workflow_plan
        ? aibleAnywhereProjects?.[agent?.id]?.executionWorkflows?.[tool?.workflow_plan]
        : undefined;
    const updateWorkflowSource = (workflow) => {
        if (!tool?.workflow_plan) {
            return;
        }
        const executionWorkflows = {
            ...(agent?.executionWorkflows ?? {}),
            [tool?.workflow_plan]: workflow
        };
        dispatch(aibleAnywhereReducer.updateBase({
            ...aibleAnywhereProjects,
            [agent?.id]: {
                ...aibleAnywhereProjects[agent?.id],
                executionWorkflows: executionWorkflows
            }
        }));
    };
    return (React.createElement("div", { className: styles.agentCTaskWrapper },
        React.createElement("div", { className: styles.agentCTaskLabel }, tool?.label),
        !backendStepAgent && (React.createElement(React.Fragment, null,
            React.createElement("div", null, "Agent Skill Instructions"),
            React.createElement("textarea", { placeholder: "Description for " + tool?.label, className: styles.aaTextArea, value: tool?.description ?? defaultToolText, onChange: (val) => {
                    const retTool = { ...tool, description: val?.currentTarget?.value };
                    const retBlueprintOptions = task?.blueprintOptions.map((bp, index) => index === toolIndex ? retTool : bp);
                    updateTask({ ...task, blueprintOptions: retBlueprintOptions }, index);
                } }))),
        backendStepAgent && (React.createElement("div", { className: "mt-[10px]" },
            React.createElement(SkillsOverview, { agent: backendStepAgent, listStepsOnly: isTemplateView, updateWorkflowSource: isTemplateView ? undefined : updateWorkflowSource }))),
        !backendStepAgent && isEnabled("chat-conversation-memory") && (React.createElement("div", { className: "mt-[10px]" },
            React.createElement(MemorySettings, { agent: agent, task: task, index: index, tool: tool, updateTask: updateTask, toolIndex: toolIndex }))),
        isGuardrailsAllowedCTool && (React.createElement("div", { className: "mt-[10px]" },
            React.createElement(CronJobTaskGuardrailsSettings, { agent: agent, task: task, index: index, tool: tool, updateTask: updateTask, toolIndex: toolIndex }))),
        (tool?.id === 4 || tool?.id === 3 || tool?.id === 1 || tool?.id === 18) && (
        // Showing data selection/selected for ANALYTICS, NLQ, DOCSUM, WHATS_CHANGED tools
        React.createElement(ToolDataSelection, { tool: tool, agent: agent, index: index, toolIndex: toolIndex, updateTask: updateTask, task: task })),
        tool?.value === "prediction_tool" && (React.createElement(PredictionConfig, { agent: agent, task: task, index: index, tool: tool, toolIndex: toolIndex, updateTask: updateTask })),
        tool?.value === "trigger_api_event" && (React.createElement(ApiTriggerConfig, { agent: agent, task: task, index: index, tool: tool, toolIndex: toolIndex, updateTask: updateTask }))));
};
const ToolDataSelection = ({ agent, task, updateTask, index, tool, toolIndex }) => {
    const dispatch = useDispatch();
    const isWhatsChangedTool = tool?.id == 18;
    const isDatasetTool = tool?.id === 4 || tool?.id === 3 || isWhatsChangedTool;
    const isDatasetNLQ = tool?.id === 3; // ID 3 is NLQ, so allow datasets without outcomes
    const isArtifactTool = tool?.id === 1;
    const isAgentTool = !isNaN(Number(tool?.value));
    const chatApps = useSelector((state) => viewReducer.getChatApps(state, true, "STANDARD")) ?? [];
    const selectedChatApp = isAgentTool ? chatApps?.find((app) => app?.id === tool?.value) : undefined;
    const datasets = useSelector((state) => homeReducer.getDatasets(state));
    const [isFetchingDataset, setIsFetchingDataset] = useState(false);
    const toolArtifactId = tool?.artifact_id;
    const getToolAgentArtifactId = () => {
        if (isAgentTool) {
            if (isArtifactTool) {
                return selectedChatApp?.wizard?.artifactId;
            }
            else if (isDatasetTool) {
                return selectedChatApp?.wizard?.datasetId;
            }
        }
        return undefined;
    };
    let retLabel = "(Optional) Select a dataset for this tool:";
    if (isDatasetTool && isAgentTool) {
        retLabel = "Selected dataset from this agent tool:";
    }
    else if (isArtifactTool && isAgentTool) {
        retLabel = "Selected artifact from this agent tool:";
    }
    else if (isArtifactTool) {
        retLabel = "(Optional) Select an artifact for this tool:";
    }
    const checkAndUpdateArtifactId = async (tries = 0, maxTries = 3) => {
        const retArtifactId = getToolAgentArtifactId();
        const isValidId = retArtifactId && !isNaN(Number(retArtifactId));
        if (isDatasetTool && isValidId) {
            if (tries < maxTries) {
                if (datasets?.[retArtifactId] === undefined) {
                    setIsFetchingDataset(true);
                    try {
                        await dispatch(homeReducer.fetchDataset(retArtifactId));
                    }
                    catch {
                        console.log("Error fetching dataset");
                    }
                    return checkAndUpdateArtifactId(tries++);
                }
                else {
                    handleUpdateSelectedToolArtifactId(retArtifactId);
                }
            }
            else {
                console.log(`Could not fetch the selected dataset after ${maxTries} attempts`);
            }
        }
        else if (isArtifactTool) {
            handleUpdateSelectedToolArtifactId(retArtifactId);
        }
        setIsFetchingDataset(false);
    };
    useEffect(() => {
        if (isAgentTool && selectedChatApp) {
            checkAndUpdateArtifactId();
        }
    }, []);
    const handleUpdateSelectedToolArtifactId = (val) => {
        const isValidDatasetId = !isNaN(Number(val));
        if (isValidDatasetId) {
            const toolUpdate = {
                ...tool,
                artifact_id: Number(val)
            };
            const blueprintOptionsUpdate = (task?.blueprintOptions ?? []).map((bpOption, index) => {
                if (index == toolIndex) {
                    return toolUpdate;
                }
                return bpOption;
            });
            const taskUpdate = {
                ...task,
                blueprintOptions: blueprintOptionsUpdate
            };
            updateTask(taskUpdate, index);
        }
        else {
            const toolUpdate = {
                ...tool
            };
            if (tool?.artifact_id) {
                delete toolUpdate.artifact_id;
            }
            const blueprintOptionsUpdate = (task?.blueprintOptions ?? []).map((bpOption, index) => {
                if (index == toolIndex) {
                    return toolUpdate;
                }
                return bpOption;
            });
            const taskUpdate = {
                ...task,
                blueprintOptions: blueprintOptionsUpdate
            };
            updateTask(taskUpdate, index);
        }
    };
    return (React.createElement("div", { className: "mt-[16px]" },
        React.createElement("div", null, retLabel),
        React.createElement("div", { className: "mt-[2px]" }, isDatasetTool ? (React.createElement("div", { className: "w-[100%]" }, isFetchingDataset ? (React.createElement("div", { className: "flex items-center" },
            React.createElement(LoadingIndicator, { style: { margin: "4px", transform: "scale(0.6)" } }),
            React.createElement("div", null, "Loading data..."))) : (React.createElement(DatasetSelector, { datasetId: toolArtifactId, onChange: (val) => handleUpdateSelectedToolArtifactId(val), allowAllDatasets: isDatasetNLQ, hideJustChat: true, allowOutcomeSelect: false, allowUpload: false, includeSelectedDataset: isAgentTool, filter: isWhatsChangedTool ? "date" : undefined, hideDataSearch: isWhatsChangedTool, checkRawFieldsFilter: isWhatsChangedTool })))) : (React.createElement("div", { className: "w-[100%]" },
            React.createElement(DocumentSelector, { artifactId: toolArtifactId, onChange: (val) => handleUpdateSelectedToolArtifactId(val?.id) }))))));
};
const ApiTriggerConfig = ({ agent, task, updateTask, index, tool, toolIndex }) => {
    const dispatch = useDispatch();
    const updateToolValue = (key, value) => {
        const toolUpdate = {
            ...tool,
            [key]: value
        };
        const blueprintOptionsUpdate = (task?.blueprintOptions ?? []).map((bpOption, i) => {
            if (i == toolIndex) {
                return toolUpdate;
            }
            return bpOption;
        });
        const taskUpdate = {
            ...task,
            blueprintOptions: blueprintOptionsUpdate
        };
        updateTask(taskUpdate, index);
    };
    return (React.createElement("div", { className: styles.predictionConfig },
        React.createElement("div", { style: { fontWeight: "bold" } }, "API Location"),
        React.createElement("div", { className: "flex items-center", onClick: () => {
                updateToolValue("webhook_target", "local");
            } },
            React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: tool?.webhook_target === "local" }),
            "Local"),
        React.createElement("div", { className: "flex items-center", onClick: () => {
                updateToolValue("webhook_target", "remote");
            } },
            React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: tool?.webhook_target === "remote" }),
            "Remote"),
        React.createElement("div", { style: { fontWeight: "bold", marginTop: "4px" } }, "Trigger API Hook"),
        React.createElement("input", { className: styles.agentCTextInput, value: tool.webhook_name, placeholder: "Input API hook trigger", onChange: (e) => {
                const value = e.currentTarget.value;
                updateToolValue("webhook_name", value);
            } })));
};
const PredictionConfig = ({ agent, task, updateTask, index, tool, toolIndex }) => {
    const dispatch = useDispatch();
    const [isLoadingOptimize, setIsLoadingOptimize] = useState(false);
    const reports = useSelector((state) => viewReducer.getReports(state));
    const predictNextId = useSelector((state) => aibleAnywhereReducer.getPredictNextId(state));
    const hasPredictConfig = predictNextId !== undefined;
    const optimizeReports = (reports ?? [])?.filter((r) => r?.metadata?.explorations?.[0]?.projectId !== undefined || r?.metadata?.chatGPTConvo?.optimizeSetup !== undefined);
    const reportOptions = (optimizeReports ?? []).reverse().map((o) => ({
        label: o?.metadata?.explorations?.[0]?.reportLabel ?? o?.name,
        value: o?.id
    }));
    const handlePredictNextSelect = (nextPredictVal) => {
        const targetReport = reports?.find((report) => report?.id === nextPredictVal);
        if (nextPredictVal === "CREATE_NEW" || nextPredictVal === undefined) {
            // Also update the prediction tool with datasetId and projectId
            const toolUpdate = {
                ...tool
            };
            if (toolUpdate?.artifact_id) {
                delete toolUpdate.artifact_id;
            }
            if (toolUpdate?.model_id) {
                delete toolUpdate.model_id;
            }
            if (toolUpdate?.predictNextId) {
                delete toolUpdate.predictNextId;
            }
            const blueprintOptionsUpdate = (task?.blueprintOptions ?? []).map((bpOption, index) => {
                if (index == toolIndex) {
                    return toolUpdate;
                }
                return bpOption;
            });
            const taskUpdate = {
                ...task,
                blueprintOptions: blueprintOptionsUpdate,
                predictNextId: nextPredictVal
            };
            updateTask(taskUpdate, index);
        }
        else {
            // Also update the prediction tool with datasetId and projectId
            const predictionDataset = targetReport?.metadata?.explorations?.[0]?.datasetId;
            const predictionProjectId = targetReport?.metadata?.explorations?.[0]?.projectId;
            const toolUpdate = {
                ...tool,
                artifact_id: predictionDataset ? Number(predictionDataset) : undefined,
                model_id: predictionProjectId ? Number(predictionProjectId) : undefined,
                predictNextId: nextPredictVal
            };
            const blueprintOptionsUpdate = (task?.blueprintOptions ?? []).map((bpOption, index) => {
                if (index == toolIndex) {
                    return toolUpdate;
                }
                return bpOption;
            });
            const taskUpdate = {
                ...task,
                blueprintOptions: blueprintOptionsUpdate,
                predictNextId: nextPredictVal
            };
            updateTask(taskUpdate, index);
        }
    };
    return (React.createElement("div", { className: styles.predictionConfig },
        React.createElement("div", { style: { fontWeight: "bold" } }, "Choose Optimize Project: "),
        React.createElement(Select, { options: [{ label: "Create New", value: "CREATE_NEW" }, ...(reportOptions ?? [])], onChange: (val) => {
                handlePredictNextSelect(val?.value);
            }, value: reportOptions.find((r) => task?.predictNextId !== undefined && r?.value === task?.predictNextId) }),
        React.createElement("div", { className: "mt-[5px] flex items-center" },
            React.createElement(Button, { onClick: async () => {
                    try {
                        setIsLoadingOptimize(true);
                        if (task?.predictNextId === "CREATE_NEW" || task?.predictNextId === undefined) {
                            await dispatch(nextReducer.init("new"));
                            dispatch(aibleAnywhereReducer.updatePredictNextId("new"));
                            await dispatch(chatGPTReducer.initOptimizeSteps());
                            const saveNextId = await dispatch(nextReducer.saveNext("new", undefined, false, true));
                            dispatch(aibleAnywhereReducer.updatePredictNextId(saveNextId));
                            updateTask({ ...task, ["predictNextId"]: saveNextId }, index);
                            dispatch(reportReducer.fetchReport(saveNextId));
                        }
                        else {
                            await dispatch(nextReducer.init(task?.predictNextId));
                            dispatch(aibleAnywhereReducer.initSafeClawOptimize(task?.predictNextId));
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                    setIsLoadingOptimize(false);
                }, disabled: task?.predictNextId === undefined, isLoading: isLoadingOptimize, style: { minWidth: "95px" } }, "Configure"),
            hasPredictConfig && (React.createElement(Button, { style: { marginLeft: "10px" }, onClick: () => {
                    dispatch(aibleAnywhereReducer.updatePredictNextId(undefined));
                    dispatch(aibleAnywhereReducer.initClawTest(agent?.id, task));
                    dispatch(chatGPTReducer.updateConversation({})); // Clear out the chat conversation on back
                } }, "Back")))));
};
const MemorySettings = ({ agent, task, updateTask, index, tool, toolIndex }) => {
    const MemoryTypes = useSelector((state) => getMultiSessionMemoryTypes(state));
    const MemoryTypesList = Object.keys(MemoryTypes);
    const [readMemoryEnabled, setReadMemoryEnabled] = useState(false);
    const [createMemoryEnabled, setCreateMemoryEnabled] = useState(true);
    const disableReadMemory = !isEnabled("aible-claw-read-memory") && !agent?.id;
    const MemoryCount = useSelector((state) => getMultiSessionMemoryCount(state));
    const bpMemoryConfig = tool?.memory_config;
    const bpMemoryConfigList = bpMemoryConfig?.configs;
    const toggleMemoryEnabled = (target) => {
        if (target === "READ" && !isEnabled("aible-claw-read-memory")) {
            return;
        }
        const targetKey = target === "READ" ? "enable_augmentation" : "enable_creation";
        const targetState = target === "READ" ? readMemoryEnabled : createMemoryEnabled;
        const targetUpdate = target === "READ" ? setReadMemoryEnabled : setCreateMemoryEnabled;
        if (targetState !== true) {
            return targetUpdate(true);
        }
        else {
            let retBpMemoryConfigList = [...(bpMemoryConfigList ?? [])];
            retBpMemoryConfigList = retBpMemoryConfigList
                .map((config) => {
                const updatedConfig = {
                    ...config,
                    [targetKey]: false
                };
                if (!updatedConfig?.enable_creation && !updatedConfig?.enable_augmentation) {
                    return undefined;
                }
                return updatedConfig;
            })
                .filter((config) => config !== undefined);
            const updatedHasEnabledConfigs = retBpMemoryConfigList?.some((config) => config?.enable_creation || config?.enable_augmentation);
            const toolUpdate = {
                ...tool,
                memory_config: {
                    ...(tool?.memory_config ?? {}),
                    memory_count: MemoryCount,
                    configs: retBpMemoryConfigList
                }
            };
            if (!updatedHasEnabledConfigs) {
                delete toolUpdate.memory_config;
            }
            const retBlueprintOptions = task?.blueprintOptions.map((bpO, index) => index === toolIndex ? toolUpdate : bpO);
            updateTask({ ...task, blueprintOptions: retBlueprintOptions }, index);
            return targetUpdate(false);
        }
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "font-bold" }, "Memory Permissions"),
        React.createElement("div", null,
            React.createElement("div", { className: "flex items-center", onClick: () => {
                    toggleMemoryEnabled("READ");
                } },
                React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: readMemoryEnabled, disabled: disableReadMemory }),
                "Read Memory"),
            readMemoryEnabled &&
                MemoryTypesList.map((mId) => (React.createElement(ToolMemoryType, { key: `task_memoryType_${mId}`, agent: agent, memoryId: mId, task: task, index: index, tool: tool, updateTask: updateTask, type: "READ", toolIndex: toolIndex })))),
        React.createElement("div", null,
            React.createElement("div", { className: "flex items-center", onClick: () => {
                    toggleMemoryEnabled("WRITE");
                } },
                React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: createMemoryEnabled }),
                "Write Memory"),
            createMemoryEnabled &&
                MemoryTypesList.map((mId) => (React.createElement(ToolMemoryType, { key: `task_memoryType_${mId}`, agent: agent, memoryId: mId, task: task, index: index, tool: tool, updateTask: updateTask, type: "WRITE", toolIndex: toolIndex }))))));
};
const updateFromToggleMemoryBlueprintOption = (bpConfigList, currMemoryType, enabledState, bp, cronJob, MemoryCount, targetKey, toolIndex) => {
    let retConfigList = [...(bpConfigList ?? [])];
    const targetConfigIndex = retConfigList?.findIndex((config) => config?.topic === currMemoryType?.topic);
    if (!enabledState) {
        if (targetConfigIndex !== -1) {
            const updatedConfig = {
                ...retConfigList[targetConfigIndex],
                [targetKey]: true
            };
            retConfigList = retConfigList.map((config, index) => (index === targetConfigIndex ? updatedConfig : config));
        }
        else {
            const baseConfig = {
                topic: currMemoryType?.topic,
                enable_augmentation: false,
                retrieval_scope: currMemoryType?.retrievalScope,
                enable_creation: false,
                creation_prompt_template: currMemoryType?.creationPromptTemplate ?? ""
            };
            const newConfig = {
                ...baseConfig,
                [targetKey]: true
            };
            retConfigList.push(newConfig);
        }
        const bpUpdate = {
            ...bp,
            memory_config: {
                ...(bp?.memory_config ?? {}),
                memory_count: MemoryCount,
                configs: retConfigList
            }
        };
        const retBlueprintOptions = cronJob?.blueprintOptions.map((bpO, index) => index === toolIndex ? bpUpdate : bpO);
        return retBlueprintOptions;
    }
    else {
        if (targetConfigIndex !== -1) {
            const updatedConfig = {
                ...retConfigList[targetConfigIndex],
                [targetKey]: false
            };
            if (updatedConfig?.enable_creation || updatedConfig?.enable_augmentation) {
                retConfigList = retConfigList.map((config, index) => (index === targetConfigIndex ? updatedConfig : config));
            }
            else {
                retConfigList = retConfigList.filter((config, index) => index !== targetConfigIndex);
            }
            const updatedHasEnabledConfigs = retConfigList?.some((config) => config?.enable_creation || config?.enable_augmentation);
            const bpUpdate = {
                ...bp,
                memory_config: {
                    ...(bp?.memory_config ?? {}),
                    memory_count: MemoryCount,
                    configs: retConfigList
                }
            };
            if (!updatedHasEnabledConfigs) {
                delete bpUpdate.memory_config;
            }
            const retBlueprintOptions = cronJob?.blueprintOptions.map((bpO, index) => index === toolIndex ? bpUpdate : bpO);
            return retBlueprintOptions;
        }
    }
};
const ToolMemoryType = ({ memoryId, task, updateTask, index, tool, type, toolIndex }) => {
    const MemoryTypes = useSelector((state) => getMultiSessionMemoryTypes(state));
    const MemoryCount = useSelector((state) => getMultiSessionMemoryCount(state));
    const currMemoryType = MemoryTypes?.[memoryId];
    const memoryType = useSelector((state) => getMultiSessionMemoryTypeById(state, memoryId));
    const bpMemoryConfig = tool?.memory_config;
    const bpMemoryConfigList = bpMemoryConfig?.configs;
    const currentBpMemoryConfig = bpMemoryConfigList && bpMemoryConfigList.find((config) => config?.topic === currMemoryType?.topic);
    const targetKey = type === "WRITE" ? "enable_creation" : "enable_augmentation";
    const isMemoryEnabled = currentBpMemoryConfig && currentBpMemoryConfig?.[targetKey];
    const toggleCreateEnabled = () => {
        const blueprintOptionsUpdate = updateFromToggleMemoryBlueprintOption(bpMemoryConfigList, currMemoryType, isMemoryEnabled, tool, task, MemoryCount, targetKey, toolIndex);
        updateTask({ ...task, blueprintOptions: blueprintOptionsUpdate }, index);
    };
    return (React.createElement("div", { className: "flex items-center ml-[18px]", onClick: () => {
            toggleCreateEnabled();
        } },
        React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: isMemoryEnabled }),
        React.createElement("div", { className: styles.agentCMemoryTypeText },
            React.createElement("span", { className: "font-bold mr-[8px]" }, memoryType?.label),
            React.createElement("span", null, memoryType?.description))));
};
const CronJobTaskGuardrailsSettings = ({ task, updateTask, index, tool, toolIndex }) => {
    const defaultInputInstruction = useSelector(getDefaultGuardrailsInputInstruction);
    const defaultOutputInstruction = useSelector(getDefaultGuardrailsOutputInstruction);
    const defaultSystemInstruction = useSelector(getDefaultGuardrailsSystemInstruction);
    const bpGuardrailsConfig = tool?.guardrails_config;
    const hasInputInstructions = bpGuardrailsConfig?.input_instructions !== undefined;
    const hasOuputInstructions = bpGuardrailsConfig?.output_instructions !== undefined;
    const toggleGuardrailSetting = (type) => {
        const bpGuardailsUpdate = {
            ...(bpGuardrailsConfig ?? {})
        };
        if (type === "INPUT") {
            if (bpGuardrailsConfig?.input_instructions !== undefined) {
                delete bpGuardailsUpdate.input_instructions;
            }
            else {
                bpGuardailsUpdate.input_instructions = defaultInputInstruction;
            }
        }
        else {
            if (bpGuardrailsConfig?.output_instructions !== undefined) {
                delete bpGuardailsUpdate.output_instructions;
            }
            else {
                bpGuardailsUpdate.output_instructions = defaultOutputInstruction;
            }
        }
        const hasEnabledConfigs = bpGuardailsUpdate?.input_instructions !== undefined || bpGuardailsUpdate?.output_instructions !== undefined;
        const toolUpdate = {
            ...tool
        };
        if (hasEnabledConfigs) {
            if (bpGuardailsUpdate?.system_instructions === undefined) {
                bpGuardailsUpdate.system_instructions = defaultSystemInstruction;
            }
            toolUpdate.guardrails_config = {
                ...bpGuardailsUpdate
            };
        }
        else if (!hasEnabledConfigs && toolUpdate?.guardrails_config !== undefined) {
            delete toolUpdate.guardrails_config;
        }
        const retBlueprintOptions = task?.blueprintOptions.map((bpO, index) => index === toolIndex ? toolUpdate : bpO);
        updateTask({ ...task, blueprintOptions: retBlueprintOptions }, index);
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "font-bold" }, "Guardrails Settings"),
        React.createElement("div", { className: "flex items-center", onClick: () => {
                toggleGuardrailSetting("INPUT");
            } },
            React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: hasInputInstructions }),
            "User Question Guardrails"),
        React.createElement("div", { className: "flex items-center", onClick: () => {
                toggleGuardrailSetting("OUTPUT");
            } },
            React.createElement("input", { className: "mr-[4px] mt-[-2px]", type: "checkbox", readOnly: true, checked: hasOuputInstructions }),
            "AI Response Guardrails")));
};
const Heartbeats = ({ agentC, updateAgentC }) => {
    const dispatch = useDispatch();
    const cLoading = useSelector((state) => globalReducer.getClawActivityLoad(state, agentC?.id));
    const communicationOptions = useSelector((state) => chatGPTReducer.getAgentCCommunicationOptions(state));
    const heartbeats = agentC?.heartbeats ?? [];
    const initHeartbeat = {
        prompt: undefined
    };
    const updateHeartbeat = (heartbeat, index) => {
        const retHeartbeats = heartbeats.map((cj, i) => (i === index ? heartbeat : cj));
        return updateAgentC("heartbeats", retHeartbeats);
    };
    const deleteHeartbeat = (index) => {
        const retHeartbeats = [...(heartbeats ?? [])];
        retHeartbeats.splice(index, 1);
        return updateAgentC("heartbeats", retHeartbeats);
    };
    const testHeartbeat = (heartbeat) => {
        dispatch(chatGPTReducer.updateAgentIQTools(heartbeat?.blueprintOptions));
        dispatch(chatGPTReducer.handleAgentIQ(heartbeat?.prompt, true, "reasoning", undefined, agentC?.id, heartbeat?.blueprintOptions));
    };
    const agentIqToolOptions = useSelector((state) => chatGPTReducer.getAgentIQToolOptions(agentC));
    const agentIqCustomToolOptions = useSelector((state) => chatGPTReducer.getAgentIQStepByStepTools(state));
    const options = useSelector((state) => chatGPTReducer.getAgentIQToolsAgentsOptions(state));
    const blueprintOptions = [...(agentIqToolOptions ?? []), ...(agentIqCustomToolOptions ?? []), ...(options ?? [])];
    return (React.createElement("div", { className: styles.agentCTrigger },
        React.createElement("div", { className: styles.agentCInputBold }, "Heartbeat (how often you wake up)"),
        React.createElement(Button, { onClick: () => updateAgentC("heartbeats", [...(heartbeats ?? []), { ...initHeartbeat }]) }, "Add Heartbeat"),
        heartbeats.map((heartbeat, index) => {
            const disableTest = cLoading || heartbeat?.blueprintOptions === undefined || heartbeat?.blueprintOptions?.length === 0;
            return (React.createElement("div", { className: styles.agentCJob, key: "heartbeat_" + index },
                React.createElement("div", { className: styles.agentCJobHeader },
                    React.createElement("div", { className: styles.agentCInputBold }, "Heartbeat: " + (index + 1)),
                    React.createElement(Button, { style: { padding: "3px", marginLeft: "10px" }, onClick: () => testHeartbeat(heartbeat), disabled: disableTest }, "Test Heartbeat"),
                    React.createElement(Button, { style: { padding: "3px", marginLeft: "10px" }, onClick: () => deleteHeartbeat(index) }, "Delete")),
                React.createElement(Select, { isMulti: true, options: intervalOptions, value: heartbeat?.intervalOptions, onChange: (value) => updateHeartbeat({ ...heartbeat, intervalOptions: value }, index), placeholder: "Select reminder times\u2026" }),
                React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
                    React.createElement("div", { className: styles.agentCInputBold, style: { marginTop: "5px" } }, `Prompt`),
                    React.createElement("textarea", { placeholder: "Instructions for heartbeat", className: styles.aaTextArea, value: heartbeat?.prompt, onChange: (val) => updateHeartbeat({ ...heartbeat, prompt: val.currentTarget.value }, index) })),
                React.createElement("div", { className: styles.agentCInput, style: { marginTop: "-10px" } },
                    React.createElement("div", { className: styles.agentCInputBold }, "Agents or tools it can use"),
                    React.createElement(Select, { isMulti: true, options: blueprintOptions, value: heartbeat?.blueprintOptions, onChange: (value) => updateHeartbeat({ ...heartbeat, blueprintOptions: value }, index), placeholder: "Select agents and tools..." })),
                React.createElement("div", { className: styles.agentCInput },
                    React.createElement("div", { className: styles.agentCInputBold }, "Communication channels it can access"),
                    React.createElement(Select, { isMulti: true, options: communicationOptions, value: heartbeat?.communicationOptions, onChange: (value) => updateHeartbeat({ ...heartbeat, communicationOptions: value }, index), placeholder: "Select communication channels..." }),
                    React.createElement("div", { style: { height: "10px" } }),
                    heartbeat?.communicationOptions?.find((c) => c?.value === "Slack") && (React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
                        React.createElement("div", null, "Which Slack channel should this agent post to??"),
                        React.createElement("input", { className: styles.agentCTextInput, value: heartbeat?.slackChannel, onChange: (e) => updateHeartbeat({ ...heartbeat, slackChannel: e.currentTarget.value }, index) }))),
                    heartbeat?.communicationOptions?.find((c) => c?.value === "SMS") && (React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
                        React.createElement("div", null, "What phone number should I message with updates?"),
                        React.createElement("input", { className: styles.agentCTextInput, value: heartbeat?.phoneNumber, onChange: (e) => updateHeartbeat({ ...heartbeat, phoneNumber: e.currentTarget.value }, index) }))))));
        })));
};
const APIInvocationInstructions = ({ intervalOptions }) => {
    const [language, setLanguage] = useState("CURL");
    const [showInstructions, setShowInstructions] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [url, setUrl] = useState("");
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const intervalKeyword = intervalOptions?.[0]?.value;
    const hasExamples = Boolean(url);
    const exampleText = aibleAnywhereReducer.getClawAPIActivationExample(url, intervalKeyword, language);
    const languageOptions = [
        { label: "Curl", value: "CURL" },
        { label: "Python", value: "PYTHON" },
        { label: "Javascript", value: "JAVASCRIPT" }
    ];
    const handleCopyText = async () => {
        try {
            await navigator.clipboard.writeText(exampleText);
            toast("Instructions copied to clipboard.", {
                type: toast.TYPE.SUCCESS,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
            });
        }
        catch (err) {
            console.error("Failed to copy text: ", err);
            toast("Failed to copy instructions to clipboard.", {
                type: toast.TYPE.ERROR,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
            });
        }
    };
    const handleGenerateTokens = async () => {
        setIsGenerating(true);
        try {
            // Generate the urls and save the url and token
            const client = await AibleClientFactory.getInstance().getAccountClient();
            await client
                .getCustomerClientFactory(accountId)
                .then((f) => f.getContentGenerationClient().base.baseUrl)
                .then((baseUrl) => {
                setUrl(baseUrl);
            });
        }
        catch (e) {
            console.log(e);
        }
        setIsGenerating(false);
    };
    if (!intervalOptions?.length) {
        return null;
    }
    return (React.createElement("div", { className: styles.apiInstructionsWrapper },
        React.createElement("div", { className: styles.apiInstructionsHeader },
            React.createElement("a", { onClick: () => {
                    if (!showInstructions && !hasExamples) {
                        handleGenerateTokens();
                    }
                    setShowInstructions(!showInstructions);
                } }, (showInstructions ? "Hide" : "Show") + " API Hook Trigger Instructions")),
        showInstructions && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.apiInstructionsSelector },
                React.createElement(ButtonGroup, null, languageOptions.map((o) => {
                    return (React.createElement(Button, { style: { padding: "6px" }, active: o.value === language, onClick: () => setLanguage(o.value) }, o.label));
                }))),
            React.createElement("div", { className: styles.apiInstructionsBody }, isGenerating ? (React.createElement("div", null,
                React.createElement(LoadingIndicator, null),
                React.createElement("div", { style: { textAlign: "center" } }, "Generating Examples"))) : hasExamples ? (React.createElement(React.Fragment, null,
                React.createElement(SyntaxHighlighter, { language: language === "CURL" ? "bash" : language.toLowerCase(), style: oneLight, customStyle: { maxHeight: "250px", overflowY: "auto" }, wrapLongLines: true, 
                    //Lines aren't actually wrapping, so we're using this hack
                    lineProps: { style: { wordBreak: "break-word", whiteSpace: "pre-wrap" } }, wrapLines: true }, exampleText),
                React.createElement(Button, { onClick: handleCopyText, style: { marginLeft: "auto", marginTop: "6px" } }, "Copy to Clipboard"))) : (React.createElement("div", null,
                React.createElement(Button, { onClick: handleGenerateTokens }, "Generate Examples"))))))));
};
export const APIInvocations = ({ agentC, updateAgentC, useGuardrails, forceTest, open, useCache, disableTests, isManualAgent, hideCommunicationChannels, slackChannels, fetchSlackTools, hideTools, selectWorkflowAgentOptions, isTemplateView }) => {
    const dispatch = useDispatch();
    const cLoading = useSelector((state) => globalReducer.getClawActivityLoad(state, agentC?.id));
    const apiInvocations = agentC?.apiInvocations ?? [];
    const initApiInvocation = {
        prompt: undefined
    };
    const updateApiInvocation = (apiInvocation, index) => {
        const retApiInvocations = apiInvocations.map((cj, i) => (i === index ? apiInvocation : cj));
        return updateAgentC("apiInvocations", retApiInvocations);
    };
    const deleteApiInvocation = (index) => {
        const retApiInvocations = [...(apiInvocations ?? [])];
        retApiInvocations.splice(index, 1);
        return updateAgentC("apiInvocations", retApiInvocations);
    };
    const testApiInvocation = async (apiInvocation) => {
        const sAgent = await dispatch(aibleAnywhereReducer.saveAibleAnywhere(agentC, agentC?.name, false));
        dispatch(chatGPTReducer.init());
        dispatch(chatGPTReducer.updateAgentIQTools(apiInvocation?.blueprintOptions));
        dispatch(chatGPTReducer.handleAgentIQ(apiInvocation?.prompt, true, "reasoning", undefined, sAgent?.id, apiInvocation?.blueprintOptions, useCache));
    };
    // Use the same tool options as cronJobs, same tools supported on both cronJobs/apiInvocations with no distinction
    const blueprintOptions = useSelector((state) => chatGPTReducer.getAgentCTools(state, agentC));
    const isOpenShellAssistant = agentC?.isAssistant;
    return (React.createElement("div", { className: styles.agentCTrigger },
        React.createElement("div", { style: { display: "flex", alignItems: "center", marginBottom: "8px" } },
            React.createElement("div", { className: styles.agentCInputBold }, `${apiInvocations.length ? apiInvocations.length + " " : ""}API Invocation${apiInvocations.length <= 1 ? "" : "s"}`),
            React.createElement(Button, { style: { fontSize: "16px", marginLeft: "10px" }, onClick: () => updateAgentC("apiInvocations", [...(apiInvocations ?? []), { ...initApiInvocation }]) }, "Add")),
        apiInvocations.map((apiInvocation, index) => {
            /* Hiding the memory tool from this select and still preserving it in the invocation, also prevents task settings from showing for the memory tool */
            const toolSelectVal = (apiInvocation?.blueprintOptions ?? []).filter((option) => !CLAW_HIDDEN_TOOLS.includes(option?.id));
            const disableTest = cLoading || apiInvocation?.blueprintOptions === undefined || apiInvocation?.blueprintOptions?.length === 0;
            return (React.createElement(CronJobTaskItem, { key: "api_" + index, open: open, renderIndex: index, agent: agentC, type: "API", headerActions: React.createElement("div", null,
                    !disableTests && (React.createElement(Button, { className: styles.cronJobTaskAction, onClick: () => forceTest !== undefined ? forceTest(apiInvocation, index) : testApiInvocation(apiInvocation), disabled: disableTest, isSmall: true }, "Test")),
                    React.createElement(Button, { className: styles.cronJobTaskAction, onClick: () => deleteApiInvocation(index), isSmall: true }, "Delete")), descriptionOverride: `${"API Invocation " + (index + 1)}: ${apiInvocation?.prompt ?? "Add a prompt"}` },
                React.createElement("div", { className: styles.agentCJob },
                    React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
                        React.createElement("div", { className: styles.agentCInputBold, style: { marginTop: "5px" } }, `API Hook Name`),
                        React.createElement("input", { className: styles.agentCTextInput, value: apiInvocation?.intervalOptions?.[0]?.value, placeholder: "Input API hook name", onChange: (e) => {
                                const value = e.currentTarget.value;
                                const option = { label: value, value: value, __isNew__: true };
                                updateApiInvocation({
                                    ...apiInvocation,
                                    intervalOptions: [option]
                                }, index);
                            }, onBlur: (e) => {
                                const value = apiInvocation?.intervalOptions?.[0]?.value;
                                if (String(value).toLowerCase() === "agent") {
                                    toast(`Cannot name API hook "Agent"`, {
                                        type: toast.TYPE.ERROR,
                                        position: toast.POSITION.TOP_CENTER,
                                        autoClose: 3000
                                    });
                                    const option = { label: value, value: value, __isNew__: true };
                                    updateApiInvocation({
                                        ...apiInvocation,
                                        intervalOptions: undefined
                                    }, index);
                                    e.currentTarget.value = "";
                                    return;
                                }
                            } }),
                        React.createElement(APIInvocationInstructions, { intervalOptions: apiInvocation?.intervalOptions })),
                    React.createElement("div", { className: styles.agentCInput, style: { marginTop: "10px" } },
                        React.createElement("div", { className: styles.agentCInputBold, style: { marginTop: "5px" } }, `Prompt`),
                        React.createElement("textarea", { placeholder: "Instructions for API Invocation", className: styles.aaTextArea, value: apiInvocation?.prompt, onChange: (val) => updateApiInvocation({ ...apiInvocation, prompt: val.currentTarget.value }, index) })),
                    !hideTools && (React.createElement("div", { className: "mt-[-10px] mb-[20px] w-[100%] flex flex-col" },
                        React.createElement("div", { className: styles.agentCInputBold }, "Agents or tools it can use"),
                        React.createElement("div", { className: "w-[100%]" },
                            React.createElement(Select, { isMulti: true, options: blueprintOptions, value: apiInvocation?.blueprintOptions, 
                                // onChange={(value) => updateApiInvocation({ ...apiInvocation, blueprintOptions: value }, index)}
                                onChange: (value) => {
                                    const updatedOptions = dispatch(aibleAnywhereReducer.validateClawToolSelection(value, apiInvocation?.blueprintOptions, useGuardrails));
                                    updateApiInvocation({ ...apiInvocation, blueprintOptions: updatedOptions }, index);
                                }, placeholder: "Select agents and tools..." })))),
                    selectWorkflowAgentOptions && (React.createElement("div", { className: "mt-[-10px] mb-[20px] w-[100%] flex flex-col" },
                        React.createElement("div", { className: styles.agentCInput, style: { marginTop: "-10px", width: "100%" } },
                            React.createElement("div", { className: styles.agentCInputBold, style: { marginBottom: "4px" } }, "Agents or tools it can use"),
                            React.createElement("div", { className: "w-[100%]" },
                                React.createElement(Select, { isMulti: true, options: selectWorkflowAgentOptions, value: selectWorkflowAgentOptions.filter((o) => (apiInvocation?.workflowOptions ?? []).includes(o?.value)), onChange: (selectOptions) => {
                                        const updatedApiInvocation = {
                                            ...apiInvocation,
                                            workflowOptions: selectOptions.map((o) => o.value)
                                        };
                                        updateApiInvocation(updatedApiInvocation, index);
                                    }, placeholder: "Select agents and tools..." }))))),
                    (toolSelectVal ?? []).map((bp, toolIndex) => (React.createElement(TaskSettings, { key: `cronJob_id_${bp?.id}_val_${bp?.value}`, agent: agentC, task: apiInvocation, index: index, tool: bp, toolIndex: toolIndex, updateTask: updateApiInvocation, isTemplateView: isTemplateView }))),
                    !isOpenShellAssistant && !selectWorkflowAgentOptions && !hideCommunicationChannels && (React.createElement(TaskCommunicationOptions, { task: apiInvocation, updateTask: updateApiInvocation, index: index, slackChannels: slackChannels, fetchSlackTools: fetchSlackTools })))));
        })));
};
const APITriggers = () => {
    return (React.createElement("div", { className: styles.agentCTrigger },
        React.createElement("div", { className: styles.agentCInputBold }, "API Invocation"),
        React.createElement(Button, null, "Add API Invocation")));
};
export default AgentCModal;
